import $ from 'jquery'; 
import 'owl.carousel';

import './scss/style.scss';
import 'bootstrap-sass';
import 'gasparesganga-jquery-loading-overlay';
import 'bootstrap-datepicker';
import 'email-autocomplete';
import 'mailcheck';
import 'croppie';
import 'exif-js';
import 'datatables.net';
import 'bootstrap-3-typeahead';
import intlTelInput from 'intl-tel-input';

var mapboxgl, mapboxLanguage;
if ($('.mapbox-map').length > 0) { 
    mapboxgl = require('mapbox-gl');
    mapboxLanguage = require('@mapbox/mapbox-gl-language');

    // Set map access token
    mapboxgl.accessToken = mapboxApiKey;
}

const { Loader } = require("@googlemaps/js-api-loader");

// Initialize the loader with your API key and other options
const loader = new Loader({
    apiKey: googleApiKey,
    version: "weekly",
    libraries: ["places"],
});


if ($('#document-upload-component').length > 0) {
    $('.onfido-sdk-ui-CustomFileInput-input').attr('accept', 'application/pdf, image/png, image/jpeg');
}

if ($('.international-number-input').length > 0) {
    
    $(document).ready(function(){

        var inputs = document.querySelectorAll('.international-number-input');
        var internationalMobileInputs = {};

        inputs.forEach((v,k) => {
            let inputName = v.dataset.hiddenInputName;
            internationalMobileInputs[inputName] = intlTelInput(v,{
                initialCountry: "gb",
                preferredCountries: ['gb'],
                hiddenInput: () => inputName,
                utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@19.5.5/build/js/utils.js",
                formatOnDisplay: true,
            });
        });
    });

}

if ($('#international-number-input').length > 0) {

    $(document).ready(function(){
        const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
        var input = document.querySelector('#international-number-input');
        let inputName = input.dataset.hiddenInputName || 'mobile';

        let countryCode = input.dataset.countryCode || 'auto';

        const iti = intlTelInput(input, {
            initialCountry: countryCode,
            onlyCountries: allowedUKNumber ? ["ca", "us", "gb"] : ["ca", "us"],
            showSelectedDialCode: true,
            formatOnDisplay: true,
            hiddenInput: () => inputName,
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@19.5.5/build/js/utils.js"
        });
        function validateTelephoneInput() {
            if (!input.value.trim()) {
                input.parentElement.classList.remove("form-group-error");
                $('#telephone-feedback').css('display', 'none');
                $('#mobileSbumitBtn').attr("disabled", "disabled");
            } else if (iti.isValidNumberPrecise()) {
                input.parentElement.classList.remove("form-group-error");
                $('#telephone-feedback').css('display', 'none');
                $('#mobileSbumitBtn').removeAttr('disabled');
            } else {
                const errorCode = iti.getValidationError();
                const msg = errorMap[errorCode] || "Invalid number";
                input.parentElement.classList.add("form-group-error");
                $('#telephone-feedback').css('display', 'block');
                $('#mobileSbumitBtn').attr("disabled", "disabled");
            }
        }

        input.addEventListener("countrychange", function() {
            $('#mobileSbumitBtn').attr("disabled", "disabled")
            if (input.value.trim().length > 0) {
                validateTelephoneInput();
            }
        });
        
        input.addEventListener('keyup', function() {
            validateTelephoneInput();
        });
    });

}

var formatDateParts = function(day, month, year) {
    switch (siteConfig.date_format) {
        case 'Y/m/d':
            return year + '/' + month + '/' + day;
        case 'd/m/Y':
            return day + '/' + month + '/' + year;
        default:
            return day + '/' + month + '/' + year;
    }
}

var registration = (function() {
    "use strict";
    var bindEvents = function() {
        $(".inputs").keyup(function () {
            if ($(this).val().length == $(this).attr('maxlength')) {
                var next = $('#' + $(this).data('tab-target'));
                if (next) {
                    next.focus();
                    next.select();
                } else {
                    $(this).blur();
                }
            }
        });
        $("#email").on('load', function() {
            emailautocomplete({
                suggClass: "eac-suggestion"
            });
        });
        $('#email').on('blur', function(event) {
            $(this).mailcheck({
                suggested: function(element, suggestion) {
                    // callback code
                    $('#suggestion').html('Did you mean <a href="#" id="suggestionText">' + suggestion.full + '</a>?');
                },
                empty: function(element) {
                    // callback code
                    $('#suggestion').html('');
                }
            });
        });
        $('body').on('click', '#suggestionText', function(e) {
            e.preventDefault();
            $('#email').val($(this).html());
            $('#suggestion').html('');
        });
        $('button[type=submit]').on('click', function(e){
            $('#dob').val($('#dob-year').val() + '-' + $('#dob-month').val() + '-' + $('#dob-day').val());
            $('#doi').val($('#doi-year').val() + '-' + $('#doi-month').val() + '-' + $('#doi-day').val());
        });
    };
    var init = function() {
        bindEvents();
    };
    return {
        init: init
    }
})();

var dashboard = (function() {
    "use strict";
    var init = function() {
        bindEvents();
    };

    var bindEvents = function() {
        $('.owl-carousel').owlCarousel({
            stagePadding:10,
            margin:40,
            items:1,
            lazyLoad: true,
            nav:true,
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:1
                },
                1000:{
                    items:1
                },
                1200:{
                    items:2
                },
                1400:{
                    items:2

                },
                1600:{
                    items:2
                },
                1800:{
                    items:2
                }
            }
        });
    };
    return {
        init: init
    }
})();

var submitButtonAnimation = (function() {
    "use strict";
    var bindEvents = function() {
        $("form button[type=submit]").on('click', function() {
            $("button[type=submit]", $(this).parents("form")).removeAttr("clicked");
            $(this).attr("clicked", "true");
        });
        $('button[type=submit]').closest('form').on('submit',function(e){
            var clicked = $(this).find('button[type=submit][clicked=true]');
            var loadingText = $(clicked).data('loading') != undefined ? $(clicked).data('loading') : 'Loading...';
            $(clicked).html(loadingText);
        });
    };
    var init = function() {
        bindEvents();
    };
    return {
        init: init
    }
})();

var passwordStrength = (function() {
    "use strict";

    var options = {
        minimumGroups: 3,
        minimumLength: 8,
        minimumLower: 1,
        minimumNumbers: 1,
        minimumUpper: 1
    };


    var bindEvents = function() {
        $('#password, #password-verify')
        .on('keyup', checkPassword)
        .on('focus', (e) => { 
            if (e.target.value.length > 0) checkPassword(e); 
        })
        .on('blur', () => $('.password-bad').hide());
    };

    var checkPassword = function (e) {
        var password = e.target.value;
        if (calculateStrength(password)) {
            $('.password-bad').hide();
            $('.password-good').show();
        } else {
            $('.password-bad').show();
            $('.password-good').hide();
        }
    };

    var calculateStrength = function(password) {
        var inGroups = 0;
        if (password.length >= options.minimumLength) {
            $('#password-length').addClass('complete');
        } else {
            $('#password-length').removeClass('complete');
        }
        if (password.match(/([0-9])/g)) {
            $('#password-numbers').addClass('complete');
            inGroups += 1;
        } else {
            $('#password-numbers').removeClass('complete');
        }
        if (password.match(/([A-Z])/g)) {
            $('#password-uppercase').addClass('complete');
            inGroups += 1;
        } else {
            $('#password-uppercase').removeClass('complete');
        }
        if (password.match(/([a-z])/g)) {
            $('#password-lowercase').addClass('complete');
            inGroups += 1;
        } else {
            $('#password-lowercase').removeClass('complete');
        }
        if (inGroups >= options.minimumGroups) {
            if (password.length < options.minimumLength) {
                return false;
            }
            return true;
        } else {
            return false;
        }

    };
    var init = function() {
        bindEvents();
    };
    return {
        init: init
    }
})();

var accountTabs = (function () {
    "use strict";

    var bindEvents = function() {
        $('#myModal').on('show.bs.modal', function () {
            $('.documents').on('click', doNotificationTab);
        });
    };

    var doNotificationTab = function(e) {
        e.preventDefault();
        $('.account-tabs li a[href="#documents"]').click();
        $('#myModal').modal('hide');
    };

    var init = function() {
        var tabId = window.location.hash;
        if (!tabId) {
            tabId = '#account';
        }
        var myTab = $('.account-tabs a[href=\\' + tabId + ']');
        if (myTab != null) {
            myTab.tab('show');
        }
        bindEvents();
    };
    return {
        init: init
    }

})();

var addressLookup = (function () {
    "use strict";

    var bindEvents = function() {
        $('#findAddress').on('click', doLookup);
        $('#manualAddress').on('click', manualAddress);
        $('#postcodeLookup').on('click', postcodeLookup);
        $('#select-box-address').change(toggleAddAddressButton);
        $('input[name=postcode-manual]').keyup(validateAddress);
        $('textarea[name=address-manual]').keyup(validateAddress);
        $('input[name="manual[address_line_1]"]').keyup(validateAddress);
        $('input[name="manual[address_line_4]"]').keyup(validateAddress);

        $('.findAddress').on('click', doAddressLookup);
        $('.manualAddress').on('click', manualAddressEntry);
        $('.postcodeLookup').on('click', postcodeAddressLookup);
    };

    var toggleAddAddressButton = function(e) {
        if($(this).prop('selectedIndex')) {
            $('#btn-add-address').removeAttr('disabled');
        }  else {
            $('#btn-add-address').attr("disabled", "disabled");
        }
    }

    var validateAddress = function(e) {
        if(
            ($('textarea[name=address-manual]').val() != '' && $('textarea[name=address-manual]').val() != undefined && $('input[name=postcode-manual]').val() != '') ||
            (
                $('input[name="manual[address_line_1]"]').val() != '' && $('input[name="manual[address_line_1]"]').val() != undefined 
                && $('input[name="manual[address_line_4]"]').val() != '' && $('input[name="manual[address_line_4]"]').val() != undefined 
                && $('input[name=postcode-manual]').val() != ''
            )
        ) {
            $('#btn-add-address').removeAttr('disabled');
        } else {
            $('#btn-add-address').attr("disabled", "disabled");
        }
    }

    var postcodeLookup = function(e) {
        e.preventDefault();
        $('textarea[name=address-manual]').val('');
        $('input[name=postcode-manual]').val('');
        $('.address-lookup').slideDown();
        $('.address-manual').slideUp();
        $('#btn-add-address').attr("disabled", "disabled");
    };

    var postcodeAddressLookup = function(e) {
        e.preventDefault();
        var id = $(this).attr('rel');
        $('#address-manual-'+id).val('');
        $('#postcode-manual-'+id).val('');
        $('#addressLoader-'+id).slideDown();
        $('#address-manual-div-'+id).slideUp();
        $('#btn-add-address').attr("disabled", "disabled");
    };


    var manualAddress = function(e) {
        e.preventDefault();
        $('.address-not-found').slideUp();
        $('input[name=postcode]').val('');
        $('#select-box-address')
            .find('option')
            .remove();
        $('.address-list-select').slideUp();
        $('.address-lookup').slideUp();
        $('.address-manual').slideDown();
        $('#btn-add-address').attr("disabled", "disabled");
    };

    var manualAddressEntry = function(e) {
        e.preventDefault();
        var id = $(this).attr('rel');
        $('#address-not-found-'+id).fadeOut();
        $('#postcode-'+id).val('');
        $('#select-box-address-'+id)
            .find('option')
            .remove();
        $('#address-list-select-'+id).slideUp();
        $('#addressLoader-'+id).slideUp();
        $('#address-manual-div-'+id).slideDown();
        $('#btn-add-address').attr("disabled", "disabled");
    };

    var doAddressLookup = function(e) {
        e.preventDefault();
        var id = $(this).data().id;
        $('#address-not-found-'+id).fadeOut();

        var postcode = $('#postcode-'+id).val().replace(/ +/g, '');
        var country = $('#select-box-country-'+id).val().replace(/ +/g, '');
        $(this).closest('div.input-group').removeClass('form-group-error');
        if (!postcode) {
            $(this).closest('div.input-group').addClass('form-group-error');
        } else {
            $('#addressLoader-'+id).LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
            $('#select-box-address-'+id)
                .find('option')
                .remove();

            var api = {
                endpoint: '/ajax/address/' + postcode + '/' + country
            };

            $.getJSON(api.endpoint).then(function(response) {
                if (response.addresses && response.count > 0) {
                    $('#select-box-address-'+id).append($('<option>', {
                        value: '',
                        text: 'Please Select'
                    }));
                    $.each(response.addresses, function (index, value) {
                        $('#select-box-address-'+id).append($('<option>', {
                            value: index,
                            text: index
                        }));
                    });
                    $('#addressLoader-'+id).LoadingOverlay('hide');
                    $('#address-list-select-'+id).fadeIn();
                } else {
                    $('#address-list-select-'+id).hide();
                    $('#addressLoader-'+id).LoadingOverlay('hide');
                    $(this).closest('div.form-control').addClass('form-group-error');
                    $('#address-not-found-'+id).fadeIn();
                }
            }).catch(handleError);
        }
    }

    var doLookup = function(e) {
        e.preventDefault();
        $('.address-not-found').fadeOut();
        var postcode = $(this).closest('form').find('input[name=postcode]').val().replace(/ +/g, '');
        var country = $(this).closest('form').find('select[name=country]').val().replace(/ +/g, '');
        $(this).closest('div.input-group').removeClass('form-group-error');
        if (!postcode) {
            $(this).closest('div.input-group').addClass('form-group-error');
        } else {
            $('#addressLoader').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
            $('#select-box-address')
                .find('option')
                .remove();

            var api = {
                endpoint: '/ajax/address/' + postcode + '/' + country
            };
            $.getJSON(api.endpoint).then(renderAddresses).catch(handleError);

        }
    };

    var renderAddresses = function(response) {

        if (response.addresses && response.count > 0) {
            $('#select-box-address').append($('<option>', {
                value: '',
                text: 'Please Select'
            }));
            $.each(response.addresses, function (index, value) {
                $('#select-box-address').append($('<option>', {
                    value: index,
                    text: index
                }));
            });
            $('#addressLoader').LoadingOverlay('hide');
            $('.address-list-select').fadeIn();
        } else {
            $('.address-list-select').hide();
            $('#addressLoader').LoadingOverlay('hide');
            $(this).closest('div.form-control').addClass('form-group-error');
            $('.address-not-found').fadeIn();
        }
    };

    // handle errors
    function handleError(err) {
        $('.address-list-select').hide();
        $('#addressLoader').LoadingOverlay('hide');
        $(this).closest('div.form-control').addClass('form-group-error');
        $('.address-not-found').fadeIn();
    }

    var init = function() {
        $('.address-manual').hide();
        $('#btn-add-address').attr("disabled", "disabled");
        bindEvents();
        if ($('#addressLookupTrigger').length > 0) {
            $('#findAddress').trigger('click');
        }
    };

    var addAddress = function(e) {
        $('.add-address-wrapper').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
        $('#addressAlert').addClass('hidden');
        var dataPost = $('#addressForm').serializeArray();
        dataPost.push({name:'action', value: 'validate'});
        $.ajax({
            url: $('#addressForm').attr('action'),
            type: 'POST',
            data : dataPost, 
            success: function( data, textStatus, jQxhr ){
                if(data.success) {
                    if(data.redirect != 'none') {
                        if(data.redirect == 'submit') {
                            $('#addressForm').trigger('submit');
                        } else {
                            window.location = data.redirect
                        }
                    } else {
                        $('.add-address-wrapper').LoadingOverlay('hide');
                    }
                } else {
                    $('.add-address-wrapper').LoadingOverlay('hide');
                    $('#addressAlert').html(data.message);
                    $('#addressAlert').removeClass('hidden');
                    setTimeout(function() {
                        window.scrollTo(0, 0);
                    }, 1);
                }
            },
            error: function( jqXhr, textStatus, errorThrown ){
                console.log( errorThrown );
                $('.add-address-wrapper').LoadingOverlay('hide');
                $('#addressAlert').html("Something went wrong, Please try again later");
                $('#addressAlert').removeClass('hidden');
                setTimeout(function() {
                    window.scrollTo(0, 0);
                }, 1);
            }
        });
    }

    $('#btn-add-address').on('click', addAddress);

    return {
        init: init
    }
})();

var showHide = (function () {
    "use strict";

    var bindEvents = function() {
        $('input[data-expand-target]').on('click', function (e) {
            $('.expand-target[data-expand-group=' + $(this).data('expand-group') + ']').slideUp();
            $('*[data-expand-name=' + $(this).data('expand-target') + ']').slideToggle();

        });
        $('a[data-expand-target]').on('click', function (e) {
            e.preventDefault();
            $('.expand-target[data-expand-group=' + $(this).data('expand-group') + ']').slideUp();
            $('*[data-expand-name=' + $(this).data('expand-target') + ']').slideToggle();
        });
    };

    var init = function() {
        if($('.uelnSeletion').length > 0 || $('.microchipSelection').length > 0) {
           
            
        } else {
            if(!$('.account-selction').length) {
                $('.expand-target').slideUp();
            }
            
            $('.expand-target:not([aria-expanded="true"])').slideUp();
        }
        bindEvents();
    };

    return {
        init: init
    }
})();

var newOwnerSelect = (function () {
    "use strict";

    var bindEvents = function() {
        if($('#new-owner-details-option').is(':checked') === true) {
            $('#new-owner-details-option').trigger('click');
        }

    };

    var init = function() {
        bindEvents();
    };

    return {
        init: init
    }
})();

var previousOwnerSelect = (function () {
    "use strict";

    var bindEvents = function() {
        if($('#radio-inline-1').is(':checked') === true) {
            $('#radio-inline-1').trigger('click');
        }

    };

    var init = function() {
        bindEvents();
    };

    return {
        init: init
    }
})();

var validateVerifyForm = (function () {
    "use strict";   
    var bindEvents = function() {
        const verifyFieldsets = document.querySelectorAll('.VerifyFieldset');
        const verifyFieldSetsGroup = new Set();
        const agreementCheckbox = document.getElementById('agreement');
        const submitButton = document.getElementById('submitButton');
        submitButton.disabled = true;

        // Attach an event listener to all radio buttons
        verifyFieldsets.forEach(radioGroup => {
            radioGroup.addEventListener('change', checkFormValidity);
            verifyFieldSetsGroup.add(radioGroup.name);
        });

        // Attach an event listener to the agreement checkbox
        agreementCheckbox.addEventListener('change', checkFormValidity);

        function checkFormValidity() {
            // Check if at least one option is selected in each radio group
            const groups = new Set();
            
            verifyFieldsets.forEach(radioButton => {
                if (radioButton.checked) {
                    groups.add(radioButton.name);
                }
            });

            // Enable the submit button only if all radio groups have at least one option selected and the agreement checkbox is checked
            submitButton.disabled = !(groups.size === verifyFieldSetsGroup.size && agreementCheckbox.checked);
        }
    };

    var init = function() {
        if ($('#registerVerifyForm').length) {
            bindEvents();
        }
    };

    return {
        init: init
    }
})();

var addMicrochip = (function() {
    "use strict";
    var bindEvents = function() {
        $('#addMicrochip').on('click', function(e) {
            e.preventDefault();
            var form = $('#addMicrochipForm').data('add-microchip');
            $('#microchip-list').append(form);
        });
        $('body').on('click', '.delete-microchip', function(e) {
            $(this).closest('.form-group').slideUp().remove();
        });

        var theParent = document.querySelector("#microchip-list");

        if(theParent){
            theParent.addEventListener("input", function (e) {
                if (e.target !== e.currentTarget) {
                    var microchipNumber = e.target;
                    if (microchipNumber.validity.patternMismatch) {
                        microchipNumber.setCustomValidity('Please enter an alphanumeric value of 9 to 15 characters in length');
                    } else {
                        microchipNumber.setCustomValidity('');
                    }
                }
            });
        }
    };

    var init = function() {
        bindEvents();
    };

    return {
        init: init
    }
})();

var passwordBox = (function() {
    "use strict";
    var bindEvents = function() {
        $('.password-toggle').click(function(e){
            e.preventDefault();
            var passwordBox = $(this).closest('div').find('input.password-input');
            var value = passwordBox[0].value;
            if (passwordBox[0].type == "password") {
                $(this).closest('div').find('.show-password').hide();
                $(this).closest('div').find('.hide-password').show();
                passwordBox[0].type = "text";
            } else {
                $(this).closest('div').find('.show-password').show();
                $(this).closest('div').find('.hide-password').hide();
                passwordBox[0].type = "password";
            }
            passwordBox[0].value = value;

        });
    };

    var init = function() {
        bindEvents();
    };

    return {
        init: init
    }
})();

var formConfirm = (function() {
    "use strict";
    var bindEvents = function() {
        $('#confirm').on('click change', function() {
            if ($(this).is(':checked')) {
                $('#submit').removeAttr('disabled');
            } else {
                $('#submit').attr("disabled", "disabled");
            }
        });
    };

    var init = function() {
        $('#submit').attr("disabled", "disabled");
        bindEvents();
    };

    return {
        init: init
    }
})();

var reasonConfirm = (function() {
    "use strict";
    var bindEvents = function() {
        $('.reasonConfirm').on('click', function(e) {
            if ($(this).is(':checked')) {
                $('#submit').removeAttr('disabled');
            } else {
                $('#submit').attr("disabled", "disabled");
            }
        });
    };

    var init = function() {
        $('#submit').attr("disabled", "disabled");
        bindEvents();
    };

    return {
        init: init
    }
})();

var modalControl = (function() {
    "use strict";
    var init = function() {
        $('.coming-soon-modal').on('click', function(e) {
            e.preventDefault();
            $.get('/ajax/modal/coming-soon', displayModal);
        });
        $('.coming-soon-modal-marketing-signup').on('click', function(e) {
            e.preventDefault();
            $.get('/ajax/modal/coming-soon-marketing-signup?isSubscribedToMarketing=' + $(this).data('is-subscribed'), displayModal);
        });
        $('a[data-modal-target]').on('click', function(e) {
            var modalTarget = $(this).data('modal-target');
            if (modalTarget) {
                $.get('/ajax/modal/' + modalTarget, displayModal);
            }
        });
        $('a.modal-page').on('click', function(e) {
            e.preventDefault();
            var modalPage = $(this).attr('href');
            if (modalPage) {
                $.get(modalPage, displayModal);
            }
        });
        var modalTarget = $('#modalTarget').data('modal-target');
        if (modalTarget) {
           if (modalTarget === 'subscription-success') {
            subscriptionSuccess();
           }   
            $.get('/ajax/modal/' + modalTarget, displayModal);
        }
        $('a[data-modal-medium-target]').on('click', function(e) {
            var modalTarget = $(this).data('modal-medium-target');
            if (modalTarget) {
                $.get('/ajax/modal/' + modalTarget, displayMediumModal);
            }
        });

        $('#myModal').on('hidden.bs.modal', function () {
            if ($('.mobile-code-verify').length > 0) {
                $('.mobile-code-verify:first').focus();
            }
        });
    };

    var displayModal = function (data, status) {
        if (data.html) {
            $('#myModal .modal-body').html(data.html);
        } else {
            $('#myModal .modal-body').html(data);
        }
        $('#myModal').modal('show');
    };

    var displayMediumModal = function (data, status) {
        if (data.html) {
            $('#mediumModal .modal-body').html(data.html);
        } else {
            $('#mediumModal .modal-body').html(data);
        }
        $('#mediumModal').modal('show');
    };

    return {
        init: init
    }
})();

var emailVerifiedPoll = (function() {
    "use strict";
    var bindEvents = function() {
        $('#email-verification-pending').each(pollServer);
    };
    var pollServer = function() {
        setTimeout(function() {
            $.ajax({
                url: "/ajax/user/email-verification-status",
                type: "GET",
                success: checkStatus,
                dataType: "json",
                complete: pollServer,
                timeout: 2000
            })
        }, 5000);
    };
    var checkStatus = function(data) {
        if (data.status) {
            location.href='/user/refresh';
        }
    };
    var init = function() {
        bindEvents();
    };
    return {
        init: init
    }
})();

var identityVerifiedPoll = (function() {
    "use strict";
    var bindEvents = function() {
        $('#identity-check').each(pollServer);
    };
    var pollServer = function() {
        setTimeout(function() {
            $.ajax({
                url: "/ajax/user/identity-verification-status",
                type: "GET",
                success: checkStatus,
                dataType: "json",
                complete: pollServer,
                timeout: 2000
            })
        }, 5000);
    };
    var checkStatus = function(data) {
        if (data.status == 'completed-failed') {
            location.href='/dashboard/verify/identity-failed';
        }
        if (data.status == 'completed-success') {
            location.href='/dashboard/verify/identity-success';
        }
        if (data.status == 'completed-name-failed') {
            location.href='/dashboard/verify/identity-name-failed';
        }
    };
    var init = function() {
        bindEvents();
    };
    return {
        init: init
    }
})();

var mobileVerifiedPoll = (function() {
    "use strict";
    var bindEvents = function() {
        $('#mobile-check').each(pollServer);
    };
    var pollServer = function() {
        setTimeout(function() {
            $.ajax({
                url: "/ajax/user/mobile-verification-status",
                type: "GET",
                success: checkStatus,
                dataType: "json",
                complete: pollServer,
                timeout: 2000
            })
        }, 5000);
    };
    var checkStatus = function(data) {
        if (data.status == 'completed-failed') {
            location.href='/dashboard/verify/mobile-failed';
        }
        if (data.status == 'completed-success') {
            location.href='/dashboard/verify/mobile-success';
        }
    };
    var init = function() {
        bindEvents();
    };
    return {
        init: init
    }
})();

var locationType = (function() {
    "use strict";
    var bindEvents = function() {
        $('select[name=keeperType]').on('change', updateLabel);
    };
    var updateLabel = function() {
        $('#keeper-name-group').slideDown();
        $('label.keeperName').html($('select[name=keeperType] :selected').text() + ' Name');
    };
    var init = function() {
        $('#keeper-name-group').slideUp();
        bindEvents()
    };
    return {
        init: init
    }
})();

var locationChange = (function() {
    "use strict";
    var bindEvents = function() {
        $('.keeperType').on('change', updateKeeperLabel);
    };
    var updateKeeperLabel = function() {
        $('#'+$(this).attr('id')+'-name-group').slideDown();
        $('#'+$(this).attr('id')+'-name').html($('#'+$(this).attr('id')+' :selected').text() + ' Name');
    };
    var init = function() {
        bindEvents()
    };
    return {
        init: init
    }
})();

var btnLocationSubmit = (function() {
    "use strict";
    var bindEvents = function() {
        $('#btnLocationSubmit').on('click', saveLocationData);
    };

    var saveLocationData= function() {
        var equineIds = $('#equineIds').val();
        var equines = [];
        equines = equineIds.split(",");
        var error = [];
        $('#locationAlert').hide();
        $.each(equines, function( index, value ) {

            var postcode = $('#postcode-'+value).val();
            var postcodeManual = $('#postcode-manual-'+value).val();

            var keeperType = $('#keeper-type-'+value).val();
            var keeperName = $('#keeper-name-'+value).val();
            var addressManual = $('#address-manual-'+value).val();
            var selectAddress = $('#select-box-address-'+value).val();

            if(postcode == '' && postcodeManual == '') {
                if(error.indexOf(value) == -1){
                    error.push(value);
                }
            }

            if((addressManual == '' || addressManual == null) && (selectAddress == '' || selectAddress == null)) {
                if(error.indexOf(value) == -1){
                    error.push(value);
                }
            }

            if(keeperType == '' || keeperType == null) {
                if(error.indexOf(value) == -1){
                    error.push(value);
                }
            }

            if(keeperName == '') {
                if(error.indexOf(value) == -1){
                    error.push(value);
                }
            }
            if(error.indexOf(value) > -1){
                $('#location-added-'+value).hide();
                $('#location-added-error-'+value).show();
                $('#location-arrow-'+value).hide();
            } else {
                $('#location-added-'+value).show();
                $('#location-added-error-'+value).hide();
                $('#location-arrow-'+value).hide();
            }
        });

        if(error.length <= 0) {
            $('#frmLocation').submit();
        } else {
            $('#locationAlert').show();
        }
    };

    var init = function() {
        bindEvents()
    };

    return {
        init: init
    }

})();

var saveVehicles= (function() {
    "use strict";
    var bindEvents = function() {
        $('.save-vehicle-ticket').on('click', saveVehicles);
    };

    var saveVehicles= function() {
        var id = $(this).attr('rel');
        var panelId = $('#collapse-'+id).data().id;
           panelId = parseInt(panelId) + 1;
           if( $('.panel-collapse-'+panelId).length )
            {
                $('.riders-toggle-'+panelId).trigger('click');
            } else {
                panelId = $('#collapse-'+id).data().id;
                $('.riders-toggle-'+panelId).trigger('click');
            }
    };

    var init = function() {
        bindEvents()
    };

    return {
        init: init
    }
})();

var saveRiders = (function() {
    "use strict";
    var bindEvents = function() {
        $('.save-rider').on('click', saveRiderDetails);
    };
    var saveRiderDetails= function() {
        var id = $(this).attr('rel');
        var error = false;
        $(".form-group-error").removeClass("form-group-error");
        $('#riderAlert').addClass('hidden');

        if ($('.equine-rider-'+id+':checked').length == 0) {
            $('.equine-rider-'+id).closest('.form-group').addClass('form-group-error');
            error = true;
        }
        if($('.equine-rider-'+id+':checked').val() == 'rider') {
            if($('#firstname-'+id).val() == ''){
                $('#firstname-'+id).closest('.form-group').addClass('form-group-error');
                error = true;
            }
            if($('#surname-'+id).val() == ''){
                $('#surname-'+id).closest('.form-group').addClass('form-group-error');
                error = true;
            }
            if($('#dob-day-'+id).val() == ''){
                $('#rider-details-dob-'+id).addClass('form-group-error');
                error = true;
            }
            if($('#dob-month-'+id).val() == ''){
                $('#rider-details-dob--'+id).addClass('form-group-error');
                error = true;
            }
            if($('#dob-year-'+id).val() == ''){
                $('#rider-details-dob--'+id).addClass('form-group-error');
                error = true;
            }
        }

       if(error === false) {
           $('#location-added-'+id).show();
           $('#location-added-error-'+id).hide();
           $('#location-arrow-'+id).hide();
           var panelId = $('#collapse-'+id).data().id;
           panelId = parseInt(panelId) + 1;
           if( $('.panel-collapse-'+panelId).length )
            {
                $('.riders-toggle-'+panelId).trigger('click');
            } else {
                panelId = $('#collapse-'+id).data().id;
                $('.riders-toggle-'+panelId).trigger('click');
            }
       } else {
           $('#location-added-'+id).hide();
           $('#location-added-error-'+id).show();
           $('#riderAlert').html('Please resolve the errors below.');
           $('#riderAlert').removeClass('hidden');
           $('#location-arrow-'+id).hide();
       }
    };
    var init = function() {
        bindEvents()
    };
    return {
        init: init
    }
})();

var btnRiderSubmit = (function() {
    "use strict";
    var bindEvents = function() {
        $('#btnRiderSubmit').on('click', saveRiderData);
    };

    var saveRiderData= function() {
        var equineIds = $('#equineIds').val();
        var equines = [];
        equines = equineIds.split(",");
        var error = [];
        $('#riderAlert').addClass('hidden');
        $(".form-group-error").removeClass("form-group-error");
        $.each(equines, function( index, value ) {

            if ($('.equine-rider-'+value+':checked').length == 0) {
                if(error.indexOf(value) == -1){
                    error.push(value);
                }
            }
            if($('.equine-rider-'+value+':checked').val() == 'rider') {
                if($('#firstname-'+value).val() == ''){
                    if(error.indexOf(value) == -1){
                        error.push(value);
                    }
                }
                if($('#surname-'+value).val() == ''){
                    if(error.indexOf(value) == -1){
                        error.push(value);
                    }
                }
                if($('#dob-day-'+value).val() == ''){
                    if(error.indexOf(value) == -1){
                        error.push(value);
                    }
                }
                if($('#dob-month-'+value).val() == ''){
                    if(error.indexOf(value) == -1){
                        error.push(value);
                    }
                }
                if($('#dob-year-'+value).val() == ''){
                    if(error.indexOf(value) == -1){
                        error.push(value);
                    }
                }
            }

            if($('#confirm-rider:checked').length == 0) {
                error.push('confirm');
                $('#confirm-rider').closest('.form-group').addClass('form-group-error');
            }

            if(error.indexOf(value) > -1){
                $('#location-added-'+value).hide();
                $('#location-added-error-'+value).show();
                $('#location-arrow-'+value).hide();
            } else {
                $('#location-added-'+value).show();
                $('#location-added-error-'+value).hide();
                $('#location-arrow-'+value).hide();
            }
        });

        if(error.length <= 0) {
            $('#frmMultipleRiders').submit();
        } else {
            $('#riderAlert').html('Please resolve the errors below.');
            $('#riderAlert').removeClass('hidden');
        }
    };

    var init = function() {
        bindEvents()
    };

    return {
        init: init
    }

})();

var saveLocation = (function() {
    "use strict";
    var bindEvents = function() {
        $('.save-location').on('click', saveLocationDeatils);
    };
    var saveLocationDeatils= function() {
        var id = $(this).attr('rel');
        var error = false;
        $(".form-group-error").removeClass("form-group-error");
       $('#locationAlert').hide();
       var postcode = $('#postcode-'+id).val();
       var postcodeManual = $('#postcode-manual-'+id).val();

       var keeperType = $('#keeper-type-'+id).val();
       var keeperName = $('#keeper-name-'+id).val();
       var addressManual = $('#address-manual-'+id).val();
       var selectAddress = $('#select-box-address-'+id).val();

       if(postcode == '' && postcodeManual == '') {
           $('#postcode-'+id).closest('.form-group').addClass('form-group-error');
           $('#address-manual-'+id).parent('.form-group').addClass('form-group-error');
           $('#postcode-manual-'+id).closest('.form-group').addClass('form-group-error');
           error = true;
       }

       if((addressManual == '' || addressManual == null) && (selectAddress == '' || selectAddress == null)) {
           $('#postcode-'+id).closest('.form-group').addClass('form-group-error');
           $('#address-manual-'+id).parent('.form-group').addClass('form-group-error');
           $('#postcode-manual-'+id).closest('.form-group').addClass('form-group-error');
           error = true;
       }

       if(keeperType == '' || keeperType == null) {
           $('#keeper-type-'+id).closest('.form-group').addClass('form-group-error');
           error = true;
       }

       if(keeperName == '') {
           $('#keeper-name-'+id).closest('.form-group').addClass('form-group-error');
           error = true;
       }

       if(error === false) {
           $('#location-added-'+id).show();
           $('#location-added-error-'+id).hide();
           $('#location-arrow-'+id).hide();
           var panelId = $('#collapse-'+id).data().id;
           panelId = parseInt(panelId) + 1;
           if( $('.location-toggle-'+panelId).length )
            {
                 $('.location-toggle-'+panelId).trigger('click');
            } else {
                panelId = $('#collapse-'+id).data().id;
                $('.location-toggle-'+panelId).trigger('click');
            }
       } else {
           $('#location-added-'+id).hide();
           $('#location-added-error-'+id).show();
           $('#locationAlert').show();
           $('#location-arrow-'+id).hide();
       }


    };
    var init = function() {
        bindEvents()
    };
    return {
        init: init
    }
})();

var vaccinations = (function() {
    "use strict";
    var buildDate = function() {
        var date = new Date();
        var code = $(this).data('vaccination-code');
        var day = $('#' + code + '-day').val();
        var month = $('#' + code + '-month').val();
        var year = $('#' + code + '-year').val();
        var inputDate = new Date(year + '/' + month + '/' + day);
        if (inputDate.getTime() > date.getTime()) {
            $(this).closest('div.form-date').parent().parent().addClass('form-group-error');
            //$('#submitVaccinations').attr('disabled', 'disabled');
        } else {
            $('#' + code + '-date').val(day + '/' + month + '/' + year);
            $('#' + code + '-datepicker').datepicker('update', inputDate);
            $(this).closest('div.form-date').parent().parent().removeClass('form-group-error');
            //$('#submitVaccinations').removeAttr('disabled');
        }
    };
    var bindEvents = function() {
        $('.vaccination-year').on('change', buildDate);
        $('.vaccination-month').on('change', buildDate);
        $('.vaccination-day').on('change', buildDate);
        $('.vaccination-done').each(function() {
            $(this).on('click', closeDate);
        });
        $('.vaccination-change').each(function() {
            $(this).on('click', openDate);
        });
        $('.vaccination-option').each(function() {
            $(this).change(function() {
                var code = $(this).data('vaccination-code');

                if (this.checked) {
                    $('[data-expand-name=vaccination-' + code + ']').slideDown();
                } else {
                    $('[data-expand-name=vaccination-' + code + ']').slideUp();
                    $('#' + code + '-day').val('');
                    $('#' + code + '-month').val('');
                    $('#' + code + '-year').val('');
                    $('#vaccination-' + code + '-date').html('');
                    $('#vaccination-' + code + '-change-group').slideUp();
                    $(this).parent().parent().find('.form-group').removeClass('form-group-error');
                }
            });
        });
    };
    var openDate = function() {
        var code = $(this).data('vaccination-code');
        $('[data-expand-name=vaccination-' + code + ']').slideDown();
        $('#vaccination-' + code + '-date').html('');
        $('#vaccination-' + code + 'change-group').slideUp();
    };
    var closeDate = function() {
        var code = $(this).data('vaccination-code');
        $('[data-expand-name=vaccination-' + code + ']').slideUp();
        var day = $('#' + code + '-day').val();
        var month = $('#' + code + '-month').val();
        var year = $('#' + code + '-year').val();
        $('#vaccination-' + code + '-date').html(formatDateParts(day, month, year));
        $('#vaccination-' + code + '-change-group').slideDown();
    };
    var init = function() {
        $('.vaccination-change-group').slideUp();
        $('.vaccination-change-group-hasdata').slideDown();
        bindEvents()
    };
    return {
        init: init
    }
})();

var insurance = (function() {
    "use strict";
    var bindEvents = function() {
        $('#show-provider-custom').on('click', function(e){
            e.preventDefault();
            $('#provider_list').prop('selectedIndex',0);
            $('.show-provider-list').slideDown();
            $('.show-provider-custom').slideUp();
            $('#provider_list').slideUp();
            $('#provider_custom').slideDown();

        });
        $('#show-provider-list').on('click', function(e){
            e.preventDefault();
            $('#provider_name').val('');
            $('.show-provider-list').slideUp();
            $('.show-provider-custom').slideDown();
            $('#provider_list').slideDown();
            $('#provider_custom').slideUp();
        });

    };
    var datepicker = function() {
        $('.input-group.renewal-date').datepicker({
            format: "dd-mm-yyyy",
            autoclose: true,
            todayHighlight: true,
            startDate: '0d'
        }).on('changeDate', function(e){
            "use strict";
            var date = e.date;
            $('#renewal_day').val(date.getDate());
            $('#renewal_month').val(date.getMonth()+1);
            $('#renewal_year').val(date.getFullYear());
        });
    };
    var init = function() {
        $('.show-provider-list').hide();
        $('#provider_custom').hide();
        datepicker();
        bindEvents();
    };
    return {
        init: init
    }
})();

var reportMissing = (function() {
    var datepicker = function() {
        $('.input-group.missing-date').datepicker({
            format: "dd-mm-yyyy",
            autoclose: true,
            todayHighlight: true,
            endDate: '0d'
        }).on('changeDate', function(e){
            "use strict";
            var date = e.date;
            $('#missing-day').val(date.getDate());
            $('#missing-month').val(date.getMonth()+1);
            $('#missing-year').val(date.getFullYear());
        });
    };
    var init = function() {
        datepicker();
    };
    return {
        init: init
    }
})();

var racehorse = (function() {
    var datepicker = function() {
        $('.input-group.retired-date').datepicker({
            format: "dd-mm-yyyy",
            autoclose: true,
            todayHighlight: true,
            endDate: '0d'
        }).on('changeDate', function(e){
            "use strict";
            var date = e.date;
            $('#retired-day').val(date.getDate());
            $('#retired-month').val(date.getMonth()+1);
            $('#retired-year').val(date.getFullYear());
        });
    };
    var init = function() {
        datepicker();
        $('#no-retirement-date').on('click', function(e) {
            $('#retirement-date-section').slideUp();
            $('#show-retirement-date').parent().slideDown();

        });
        $('#show-retirement-date').on('click', function(e) {
            $('#retirement-date-section').slideDown();
            $('#show-retirement-date').parent().slideUp();
        });
    };
    return {
        init: init
    }
})();

var chipChecker = (function() {
    var bindEvents = function() {
        $('#chip-checker-form  input[name=type]').on('change', function(e) {
            if ($('#chip-checker-form  input[name=search]').val().length > 0 && $('#chip-checker-form  input[name=type]:checked').length > 0) {
                $('#chipCheckerSubmitButton').removeAttr('disabled');
            } else {
                $('#chipCheckerSubmitButton').attr('disabled', 'disabled');
            }
        });
        $('#chip-checker-form  input[name=search]').on('keyup', function(e) {
            $(this).val($(this).val().replace(' ',''));
            if ($(this).val().length > 0 && $('#chip-checker-form  input[name=type]:checked').length > 0) {
                $('#chipCheckerSubmitButton').removeAttr('disabled');
            } else {
                $('#chipCheckerSubmitButton').attr('disabled', 'disabled');
            }
        });
        $('#chip-checker-form').submit(function(e){
            e.preventDefault();
            var btnText = $('#chipCheckerSubmitButton').data().text;
            $('.chip-checker-wrapper').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
            var type = $('#chip-checker-form  input[name=type]:checked').val();
            var search = $('#chip-checker-form  input[name=search]').val();
            $.ajax({
                url: '/dashboard/chip-checker',
                dataType: 'text',
                type: 'get',
                contentType: 'application/json',

                data: {'type': type, 'search' : search},
                success: function( data, textStatus, jQxhr ){
                    $('.chip-checker-wrapper').LoadingOverlay('hide');
                    $('#chipCheckerSubmitButton').html('<i class="fa fa-search"></i> '+btnText);
                    $('#chipCheckerModal .modal-body').html(data);
                    $('#chipCheckerModal').modal('show');
                },
                error: function( jqXhr, textStatus, errorThrown ){
                    console.log( errorThrown );
                    $('.chip-checker-wrapper').LoadingOverlay('hide');
                    $('#chipCheckerSubmitButton').html('<i class="fa fa-search"></i> '+btnText);
                }
            });
        });
    };
    var init = function() {
        $('#chipCheckerSubmitButton').attr('disabled', 'disabled');
        bindEvents();
    };
    return {
        init: init
    }
})();

var chipCheckerPopup = (function() {
    var bindEvents = function() {
        $('#chipCheckerModal').on('show.bs.modal', function () {
            $('#chip-checker-popup').submit(function(e){
                e.preventDefault();
                $('.chip-checker-wrapper').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
                var type = $('#chip-checker-popup  input[name=type]:checked').val();
                var search = $('#chip-checker-popup  input[name=search]').val();
                $.ajax({
                    url: '/dashboard/chip-checker',
                    dataType: 'text',
                    type: 'get',
                    contentType: 'application/json',
                    data: {'type': type, 'search' : search},
                    success: function( data, textStatus, jQxhr ){
                        $('.chip-checker-wrapper').LoadingOverlay('hide');
                        $('#chipCheckerModal .modal-body').html(data);
                        $('#chipCheckerModal').modal('show');
                    },
                    error: function( jqXhr, textStatus, errorThrown ){
                        console.log( errorThrown );
                    }
                });
                $('.chip-checker-wrapper').LoadingOverlay('hide');
                $('#chipCheckerPopupSubmitButton').html('<i class="fa fa-search"></i> Search');
            });
        });
    };
    var init = function() {
        $('#chipCheckerPopupSubmitButton').attr('disabled', 'disabled');
        bindEvents();
    };
    return {
        init: init
    }
})();


var vehicleNumber = (function() {
    var ordinalSuffix = function (i) {
        var j = i % 10,
            k = i % 100;
        if (j == 1 && k != 11) {
            return i + "st";
        }
        if (j == 2 && k != 12) {
            return i + "nd";
        }
        if (j == 3 && k != 13) {
            return i + "rd";
        }
        return i + "th";
    }
    var bindEvents = function() {
        $('#event-vehicle').on('change', function () {
            var number = $(this).val();
            if(number > 0) {
                $(this).closest('.form-group').removeClass('form-group-error');
                $('#vehicleCollection').empty();
                for(var i=1; i<=number; i++) {
                    var vehicle = '<div class="form-group">'+
                                        '<label class="form-label" for="vehicle-reg">'+ordinalSuffix(i)+' Vehicle Registration<span class="help-text">Enter the vehicle registration number</span></label>'+
                                        '<input type="text" name="vehicle-reg[]" placeholder="e.g. VK18 5NN" class="form-control vehicle-reg">'+
                                    '</div>';
                    $('#vehicleCollection').append(vehicle);
                }
            }
        });
    };
    var init = function() {
        bindEvents();
    };
    return {
        init: init
    }
})();

var stripePayment = (function() {
    var setup = function() {
        // Create a Stripe client.
        var stripe = Stripe(stripePublicKey);

        // Create an instance of Elements.
        var elements = stripe.elements();

        // Custom styling can be passed to options when creating an Element.
        // (Note that this demo uses a wider set of styles than the guide below.)
        var style = {
            base: {
                color: '#32325d',
                lineHeight: '18px',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        // Create an instance of the card Element.
        
        var card = elements.create('card', {style: style, hidePostalCode: true});

        // Add an instance of the card Element into the `card-element` <div>.
        card.mount('#card-element');

        // Handle real-time validation errors from the card Element.
        card.addEventListener('change', function(event) {
            var displayError = document.getElementById('card-errors');
            if (event.error) {
                displayError.textContent = event.error.message;
            } else {
                displayError.textContent = '';
            }
        });

        // Handle form submission.
        var form = document.getElementById('payment-form');
        form.addEventListener('submit', function(event) {
            event.preventDefault();
            $('.overlay-loader-target').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});


            stripe.createToken(card, options).then(function(result) {
                if (result.error) {
                    // Inform the user if there was an error.
                    var errorElement = document.getElementById('card-errors');
                    errorElement.textContent = result.error.message;
                    $('.overlay-loader-target').LoadingOverlay('hide');
                } else {
                    // Send the token to your server.
                    stripeTokenHandler(result.token);
                }
            });
        });

        function stripeTokenHandler(token) {
            // Insert the token ID into the form so it gets submitted to the server
            var form = document.getElementById('payment-form');
            var hiddenInput = document.createElement('input');
            hiddenInput.setAttribute('type', 'hidden');
            hiddenInput.setAttribute('name', 'stripeToken');
            hiddenInput.setAttribute('value', token.id);
            form.appendChild(hiddenInput);

            // Submit the form
            form.submit();
        }

    };
    var init = function() {
        if ($('#payment-form').length) {
            setup();
        }
    };
    return {
        init: init
    }
})();

var stripeIntent = (function() {
    var setup = function() {
        // Create a Stripe client.
        var stripe = Stripe(stripePublicKey);

        // Create an instance of Elements.
        var elements = stripe.elements();

        // Custom styling can be passed to options when creating an Element.
        // (Note that this demo uses a wider set of styles than the guide below.)
        var style = {
            base: {
                color: '#32325d',
                lineHeight: '18px',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        // Create an instance of the card Element.
        var card = elements.create('card', {style: style, hidePostalCode: true});

        // Add an instance of the card Element into the `card-element` <div>.
        card.mount('#card-element');

        // Handle real-time validation errors from the card Element.
        card.addEventListener('change', function(event) {
            var displayError = document.getElementById('card-errors');
            if (event.error) {
                displayError.textContent = event.error.message;
            } else {
                displayError.textContent = '';
            }
        });

        // Handle form submission.
        var form = document.getElementById('payment-intent-form');
        form.addEventListener('submit', function(event) {
            event.preventDefault();

            $('#payment-intent-button').button('loading');
            stripe.confirmCardPayment(sessionId, {
                payment_method: {
                    'card': card
                }
            }).then(function(result) {
                if (result.error) {
                    $('#payment-intent-button').button('reset');
                    // Inform the user if there was an error.
                    var errorElement = document.getElementById('card-errors');
                    errorElement.textContent = result.error.message;
                    $('.stable-box-primary').LoadingOverlay('hide');
                    $('.overlay-loader-target').LoadingOverlay('hide');
                } else {
                    // Send the token to your server.
                    stripeTokenHandler(result.paymentIntent);
                }
            });
        });

        function stripeTokenHandler(token) {
            // Insert the token ID into the form so it gets submitted to the server
            var form = document.getElementById('payment-intent-form');
            var hiddenInput = document.createElement('input');
            hiddenInput.setAttribute('type', 'hidden');
            hiddenInput.setAttribute('name', 'stripeToken');
            hiddenInput.setAttribute('value', token.id);
            form.appendChild(hiddenInput);

            // Submit the form
            form.submit();
        }

    };
    var init = function() {
        if ($('#payment-intent-form').length) {
            setup();
        }
    };
    return {
        init: init
    }
})();

var changeOwnership = (function() {
    "use strict";
    var init = function() {
        $('.input-group.ownership-date').datepicker({
            format: "dd-mm-yyyy",
            autoclose: true,
            todayHighlight: true,
            endDate: '0d'
        }).on('changeDate', function(e){
            var date = e.date;
            $('#ownership-day').val(date.getDate());
            $('#ownership-month').val(date.getMonth()+1);
            $('#ownership-year').val(date.getFullYear());
        });
        $('.input-group.date-date').datepicker({
            format: "dd-mm-yyyy",
            autoclose: true,
            todayHighlight: true,
            endDate: '0d'
        }).on('changeDate', function(e){
            var date = e.date;
            $('#date-day').val(date.getDate());
            $('#date-month').val(date.getMonth()+1);
            $('#date-year').val(date.getFullYear());
        });
    };
    return {
        init: init
    }
})();

var dismissedComponents = (function() {
    "use strict";
    var init = function() {
        $('button[data-dismissed-component-id]').on('click', function(e) {
            var componentId = $(this).data('dismissed-component-id');
            var goToUrl = e.target.dataset.goToUrl;
            $.ajax({
                type: "POST",
                url    : "/ajax/user/set-user-interface-dismissed-components",
                data   : {id: componentId},
                success: function( response ) {
                    //  Do we want to respond to the dismiss action?
                    if (goToUrl !== undefined) {
                        window.location = goToUrl;
                    }
                }
            });
        });
    };
    return {
        init: init
    }
})();

var registerUpdate = (function() {
    "use strict";
    var init = function() {
        $('input[name=foodchain]').on('change', function(e) {
            if ($(this).val() == '71002') {
                $('.food-chain-warning').slideDown();
            } else {
                $('.food-chain-warning').slideUp();
            }
        });
    };
    return {
        init: init
    }
})();

var detailsIncorect = (function() {
    "use strict";
    var init = function() {
        var customPioButton = $('.pio-not-listed');
        var pioListButton = $('.pio-show-list');
        var customPioInput = $('.alt-pio');
        var pioList = $('.pio-select-list');
        customPioButton.on('click', function(e) {
            e.preventDefault();
            customPioInput.slideDown();
            $('#pio-list').prop('selectedIndex',0);
            $('#mc-pio-list').prop('selectedIndex',0);
            $('#alt-pio-name').val('');
            $('#mc-alt-pio-name').val('');
            pioList.slideUp();
            $('#searchConfirm').attr('disabled', 'disabled');
            $('#searchMicrochipConfirm').attr('disabled', 'disabled');
        });
        pioListButton.on('click', function(e) {
            e.preventDefault();
            customPioInput.slideUp();
            $('#alt-pio').val('');
            $('#mc-alt-pio').val('');
            pioList.slideDown();
            $('#searchConfirm').attr('disabled', 'disabled');
            $('#searchMicrochipConfirm').attr('disabled', 'disabled');
        });
    };
    return {
        init: init
    }
})();

var ownershipStatus = (function() {
    "use strict";
    var bindEvents = function() {
        $('input[name=ownership_status]').on('click', function(e) {
            $('#submitOwnerStatus').removeAttr('disabled');
        });
    };

    var init = function() {
        $('#submitOwnerStatus').attr("disabled", "disabled");
        bindEvents();
    };

    return {
        init: init
    }
})();

var changeReason = (function() {
    "use strict";
    var bindEvents = function() {
        $('input[name=change_reason]').on('click', function(e) {
            $('#submitChangeReason').removeAttr('disabled');
        });
    };

    var init = function() {
        $('#submitChangeReason').attr("disabled", "disabled");
        bindEvents();
    };

    return {
        init: init
    }
})();

var poaVerifiedPoll = (function() {
    "use strict";
    var bindEvents = function() {
        $('#address-check').each(pollServer);
    };
    var pollServer = function() {
        setTimeout(function() {
            $.ajax({
                url: "/ajax/user/address-verification-status",
                type: "GET",
                success: checkStatus,
                dataType: "json",
                complete: pollServer,
                timeout: 2000
            })
        }, 5000);
    };
    var checkStatus = function(data) {

        if (data.status == 'completed-failed') {
            location.href='/dashboard/verify/address-failed';
        }
        if (data.status == 'completed-success') {
            location.href='/dashboard/verify/address-success';
        }

    };
    var init = function() {
        bindEvents();
    };
    return {
        init: init
    }
})();

var universalSearch = (function() {
    var bindEvents = function() {
        $('#universal-checker-form  input[name=universal-search]').on('keyup', function(e) {
            if ($(this).val().length > 0) {
                $('#universalCheckerButton').removeAttr('disabled');
            }
            if (e.key === 'Enter') {
                e.preventDefault();
                $('#universalCheckerButton').trigger('click');
            }
        });
        $('#universalCheckerButton').on('click', function(e) {
            e.preventDefault();
            $('.universal-checker-wrapper').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
            var search = $('#universal-checker-form  input[name=universal-search]').val();
            var searchType = $('#universal-checker-form  input[name=universal-search-type]').val();
            $('#pio-details-section').css('display', 'none');
            $.ajax({
                url: '/register/lookup/universal-search',
                type: 'get',
                contentType: 'application/json',
                dataType: "json",
                data: {'search' : search, searchType: searchType},
                success: function( data, textStatus, jQxhr ){
                    if(data.found == true) {
                        if(data.type != 'ueln') {
                            if(data.type == 'owned') {
                                location.href='/register/lookup/owned';
                            } else {
                                $('.universal-checker-wrapper').LoadingOverlay('hide');
                                $('#pio-details-section').css('display', 'block');
                                $('#input-search-type').val('passport');
                                $('#input-search-passport').val(search);
                            }
                        } else {
                                $('#input-search-ueln').val(search);
                                $('#input-search-type').val('ueln');
                                $('#universal-checker-form #search').trigger('click');
                                $('.universal-checker-form').submit();
                        }
                    } else {
                        if(data.add == true) {
                            location.href='/register/equine/find';
                        } else {
                            if(data.duplicate == true) {
                                location.href='/register/lookup/exists';
                            } else {
                                if(data.foreign == true) {
                                    location.href='/register/new';
                                } else {
                                    location.href='/register/lookup/not-found';
                                }
                            }
                        }
                    }
                },
                error: function( jqXhr, textStatus, errorThrown ){
                    $('.universal-checker-wrapper').LoadingOverlay('hide');
                    $('#universalCheckerButton').html('<i class="fa fa-search"></i> Search for equine');
                }
            });
        });
    };
    var init = function() {
        $('#universalCheckerButton').attr('disabled', 'disabled');
        bindEvents();
    };
    return {
        init: init
    }
})();

var pioCountryChange = (function() {
    var bindEvents = function() {
        $('#pioCountry').on('change', function(e) {
            var country = $(this).val();
            $('#addressLoader').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
            $('#pio-list').empty();
            $.ajax({
                url: '/ajax/lookup/pio',
                type: 'get',
                contentType: 'application/json',
                dataType: "json",
                data: {'country' : country},
                success: function( data, textStatus, jQxhr ){
                    if (data.pios && data.count > 0) {
                        $('#pio-list').append($('<option>', {
                            value: '',
                            text: 'Select Pio'
                        }));
                        $.each(data.pios, function (index, value) {
                            $('#pio-list').append($('<option>', {
                                value: value,
                                text: value
                            }));
                        });
                        $('.pio-show-list').trigger('click');
                        $('#addressLoader').LoadingOverlay('hide');
                        $('.pio-show-list').show();
                    } else {
                        $('#addressLoader').LoadingOverlay('hide');
                        $('.pio-not-listed').trigger('click');
                        $('.pio-show-list').hide();
                    }
                }
            });
        });
    };
    var init = function() {
        bindEvents();
    };
    return {
        init: init
    }
})();

var selectEquinePassports = (function() {
    var bindEvents = function() {
        var selectAllInput = document.querySelector('input[name="select_all_equines"]');
        var inputs = document.querySelectorAll('input[name="equine_passport[]"]');
        if (selectAllInput) {
            selectAllInput.addEventListener('change', function(e) {
                // Loop through all inputs and set all checked properties to match the select all value
                inputs.forEach((element) => element.checked = e.target.checked);
            });
        }
        inputs.forEach(function (element) {
            element.addEventListener('change', function (e) {
                if (!e.target.checked) {
                    if (selectAllInput.checked) {
                        selectAllInput.checked = false;
                    }
                } else {
                    let hasSelectedAll = true;
                    inputs.forEach((element) => (element.checked) ? null : hasSelectedAll = false);
                    if (hasSelectedAll) {
                        selectAllInput.checked = true;
                    }
                }
            });
        });
    };
    var init = function() {
        bindEvents();
    };
    return {
        init: init
    }
})();

var selectNewUserRole = (function() {
    var bindEvents = function() {

        function handleNextStep(enable, equineID) {
            var equineCount = parseInt($('#new-user-details').data('equine-count'));

            if (equineCount > 1) {
                // enable or disable confirm button
                if (enable) {
                    $(`.confirm-equine[data-equine-id=${equineID}]`).removeClass('off').attr("disabled", false);
                } else {
                    $(`.confirm-equine[data-equine-id=${equineID}]`).addClass('off').attr("disabled", true);
                }
            } else {
                // enable or disable confirm button
                $('#invite-user').attr("disabled", !enable);
            }
        }

        // Set event for Equine Role checkboxes
        $('#new-user-details .new-user-role-checkbox').on('change', function(e) {
            var name = $(this).attr("name");
            // Get Equine UELN
            var equineID = name.substring(name.indexOf('[') + 1, name.indexOf(']'));

            let enableButton = false;
            let otherChecked = false;

            if (e.target.checked == true) {
                enableButton = true;
            }

            // Check if any checkboxes are checked and if other is checked
            $(`.new-user-role-checkbox[name="access[${equineID}][role][]"]`).each((k,v) => {
                if (v.checked == true) {
                    enableButton = true;
                    if (v.value == "1027") {
                        otherChecked = true;
                    }
                }
            });

            // If other is checked, show input and check if empty
            if (otherChecked) {
                $(`#please-specify-${equineID}`).removeClass("hide-element");

                if ($(`#please-specify-${equineID}`).find('input').val() == "") {
                    enableButton = false;
                }
            } else {
                $(`#please-specify-${equineID}`).addClass("hide-element");
            }

            handleNextStep(enableButton, equineID);
        });

        $('#new-user-details input[name$="[other_role_text]"]').on('keyup', function (e) {

            var equineID = $(this).data("equine-id");

            // Assume event only fires when "1027" checkbox is ticked.
            handleNextStep(!($(this).val() == ""), equineID);
        });

        $('#new-user-details .confirm-equine').on('click', function(e) {

            var equineID = $(this).data('equine-id');

            // Prepare elements for next steps.
            $(`.equine-toggle[data-equine-id=${equineID}]`).removeClass('off');
            $(`#accordion[data-id=equine-passport] .panel[data-equine-id=${equineID}]`).addClass("complete");

        });

        // Can only be clicked once user has confirmed the role(s)
        $('#new-user-details .equine-toggle').on('click', function(e) {

            var equineID = $(this).data('equine-id');
            var setOffClass = false;

            // Loop through panels, any that come after selected on in the DOM stay disabled
            $('#accordion[data-id=equine-passport] .panel').each((k,v) => {

                if (!setOffClass) {
                    if (v.dataset.equineId == equineID) {
                        setOffClass = true;
                    } else {
                        v.classList.add("complete");
                        return true;
                    }
                }

                v.classList.remove("complete");
                $(`.equine-toggle[data-equine-id=${v.dataset.equineId}]`).addClass("off");
                
            });
            
            $('#invite-user').addClass("hide-element");
        });

        $('#new-user-details .confirm-equine.last-equine').on('click', function (e) {
            $('#invite-user').removeClass("hide-element");
        });

    };
    var init = function() {
        bindEvents();
    };
    return {
        init: init
    }
})();

var selectEditUserRole = (function() {
    var bindEvents = function() {

        const roleIdOther = 1027;

        var formElementOriginalValues = {};

        function constructObjectFromPassport () {

            var passportObjects = {};

            $('#edit-user-details .panel').each((k,v) => {

                var equineID = v.dataset.equineId;
    
                var dataAttr = '[data-equine-id=' + equineID + ']';

                var passportObject = {
                    roles: [],
                    "1027": "",
                    pica: false,
                }

                $('#edit-user-details .panel'+dataAttr+' input[type=checkbox][name$="[role][]"]').each((k,v) => {
                    if (v.checked) {
                        passportObject.roles.push(v.value);
                        if (v.value == 1027){
                            passportObject[1027] = $('#edit-user-details input[name$="[other_role_text]"]'+dataAttr).val();
                        }
                    }
                });

                $('#edit-user-details .panel'+dataAttr+' input[type=checkbox][name$="[pica]"]').each((k,v) => {
                    passportObject.pica = v.checked;
                });

                passportObjects[equineID] = passportObject;
                
            });

            return passportObjects;

        }

        function passportChanged () {
            var passportChanged = false;

            var original = formElementOriginalValues;

            $.each(constructObjectFromPassport(), (equineId, updated) => {
                let updatedChanged = false;

                if (!original.hasOwnProperty(equineId)) {
                    updatedChanged = true;
                }

                // If the roles are different
                if (JSON.stringify(updated.roles) !== JSON.stringify(original[equineId].roles)) {
                    updatedChanged = true;
                }
                // If the other role text is different
                if (updated.roles.indexOf(1027) !== -1 && original[equineId][1027] != v[1027]) {
                    updatedChanged = true;
                }
                // If the pica value is different
                if (updated.pica != original[equineId].pica) {
                    updatedChanged = true;
                }

                if (updatedChanged) {
                    passportChanged = true;
                    $('input[name="'+equineId+'_unchanged"]').val('N');
                }
            });

            return passportChanged;
        }

        function validateAccess() {
            var equineIds = [];
            $('#accordion[data-id=edit-equine-passport] .panel').each(function(k,v) {
                equineIds.push(v.dataset.equineId);
            });

            let accessValid = true;
            for (let equineId of equineIds) {
                let roleCount = 0;
                let otherChecked = false;

                // Check if any checkboxes are checked and if other is checked
                $(`.edit-user-role-checkbox[name="access[${equineId}][role][]"]`).each((k,v) => {
                    if (v.checked == true) {
                        roleCount++;
                        if (v.value.toString() == roleIdOther) {
                            otherChecked = true;
                        }
                    }
                });

                if (!roleCount) {
                    accessValid = false;
                    continue;
                }
    
                // If other is checked, show input and check if empty
                if (otherChecked) {
                    if ($(`#please-specify-${equineId}`).find('input').val() == "") {
                        accessValid = false;
                        continue;
                    }
                }
            }

            return accessValid;
        }

        function enableSubmission() {
            var disable = !(validateAccess() && passportChanged());
            $('#edit-user-save-updates').attr("disabled", disable);
        }

        $('#edit-user-details .edit-user-role-checkbox').on('change', function (e){
            var equineId = e.target.dataset.equineId;
            if (e.target.value == roleIdOther) {
                if (e.target.checked) {
                    $(`#please-specify-${equineId}`).removeClass("hide-element");
                } else {
                    $(`#please-specify-${equineId}`).addClass("hide-element");
                }
            }
            enableSubmission();
        });

        $('#edit-user-details input[name$="[other_role_text]"]').on('keyup', function (e) {
            enableSubmission();
        });

        $('#edit-user-details input[type=checkbox][name$="[pica]"]').on('change',function (e) {
            enableSubmission();
        });
        
        $('#remove-passport #confirm-remove-passport').on('click', (event) => {
            var equineID = event.target.dataset.id;
            
            $('#accordion[data-id=edit-equine-passport] .panel[data-equine-id="'+equineID+'"]').remove();

            var form = document.getElementById('edit-user-details');

            form.innerHTML += '<input type="hidden" name="return-to-edit-access" value="true">';

            form.submit();
        });

        $('#edit-user-details .remove-passport').on('click', (event) => {

            var equineID = event.target.dataset.equineId;
            var userName = event.target.dataset.userName;
            var equineName = event.target.dataset.equineName;

            if ($('#accordion[data-id=edit-equine-passport] .panel').length > 1) {
                $('#remove-passport .fill-name').html(userName);
                $('#remove-passport .fill-equine-name').html(equineName);
                $('#remove-passport #confirm-remove-passport').attr("data-id", equineID);
        
                $('#remove-passport').modal('show');
            } else {
                var id = event.target.dataset.guid;

                $('#remove-access .fill-name').html(userName);
                $('#remove-access #confirm-remove-access').attr("href", "/user/invite/remove/" + id);

                $('#remove-access').modal('show');
            }
    

        });

        formElementOriginalValues = constructObjectFromPassport()

    };
    var init = function() {
        bindEvents();
    };
    return {
        init: init
    }
})();

/**
 * Only works for input element forms so far.
 */
var handleFormChange = (function() {
    var bindEvents = function() {

        var formElementOriginalValues = {};
        var formElementNewValues = {};

        function seeIfChanged () {

            var changed = false;

            $.each(formElementNewValues, (k, v) => {
                if (v != formElementOriginalValues[k]) {
                    changed = true;
                }
            });

            return changed;

        }

        $('.handle-form-change input').each((k,v) => {
            formElementOriginalValues[v.name] = v.value;
            formElementNewValues[v.name] = v.value;
        });

        $('.handle-form-change input').on('keyup', (event) => {

            var newValue = event.target.value;
            var field = event.target.name;

            formElementNewValues[field] = newValue;

            var submit = $('.handle-form-change button[type=submit]');

            if (!submit.attr('data-is-disabled')) {
                $('.handle-form-change button[type=submit]').attr("disabled",!seeIfChanged());
            }
        });


    };
    var init = function() {
        bindEvents();
    };
    return {
        init: init
    }
})();

var selectPicaRole = (function() {
    var bindEvents = function() {
        $('.picaSelect, .picaSelect + label').on('click', function(e) {
            var canSellId = $(this).data().id;
            if ($(`input.picaSelect[data-id="${canSellId}"]`).is(':checked')) {
                $('#sellEquine-'+canSellId).css('display', 'block');
            } else {
                $('#sellEquine-'+canSellId).css('display', 'none');
            }
            if($('.picaSelect').filter(':checked').length > 0) {
                $('#picaSomeConfirm').removeAttr('disabled');
            } else {
                $('#picaSomeConfirm').attr("disabled", true);
            }
        });

        $('.picaManageSelect').on('click',function (event) {
            var canSellId = $(this).data().id;
            $('#canSellCheckbox-'+canSellId).prop('checked', false);
            if ($(this).is(':checked')) {
                $('#canSellCheck-'+canSellId).css('display', 'block');
                $('#canSellDesc-'+canSellId).css('display', 'block');
            } else {
                $('#canSellCheck-'+canSellId).css('display', 'none');
                $('#canSellDesc-'+canSellId).css('display', 'none');
            }
            if($('.picaManageSelect').filter(':checked').length > 0) {
                $('#picaSomeConfirm').removeAttr('disabled');
            } else {
                $('#picaSomeConfirm').attr("disabled", true);
            }
        });
        $('.picaRemoveAccess').on('click',function (event) {
            var equineId = $(this).data().id;
            var equineID = event.target.dataset.equineId;
            var userName = event.target.dataset.userName;
            var equineName = event.target.dataset.equineName;
            $('#remove-pica .fill-name').html(userName);
            $('#remove-pica .fill-equine-name').html(equineName);
            $('#remove-pica #confirm-remove-passport').attr("data-id", equineID);
            $('#remove-pica').modal('show');
            $('#remove-pica #confirm-remove-pica').on('click', function() {
                $.ajax({
                    type: "POST",
                    url    : "/user/invite/remove-pica",
                    data   : {equineId: equineID},
                    dataType: "json",
                    success: function( response ) {
                        $('.stable-box-primary').LoadingOverlay('hide');
                        if(response.success) {
                            $('#noPicaAll-'+equineID).css('display', 'block');
                            $('#yesPicaAll-'+equineID).css('display', 'none');
                            $('#yesCanSell-'+equineID).css('display', 'block');
                            $('#noCanSell-'+equineID).css('display', 'none');

                            $('#noPicaSome-'+equineID).css('display', 'block');
                            $('#yesPicaSome-'+equineID).css('display', 'none');
                            $('#yesCanSellSome-'+equineID).css('display', 'block');
                            $('#noCanSellSome-'+equineID).css('display', 'none');
                            var picaCount = parseInt($('#picaCount').val());
                            picaCount = picaCount - 1;
                            $('#picaCount').val(picaCount);
                            if(picaCount == 0) {
                                $('#picaAllConfirm').removeAttr('disabled');
                            }
                            $('#picaRemoveSection').css('display', 'none');
                            $('#singlePicaInfo').css('display', 'none');
                            $('#singlePicaSelectionDesc').css('display', 'block');
                            $('#singlePicaSelection').css('display', 'block');
                            $('#picaAllConfirm').removeAttr('disabled');
                            $('#picaRemoveSection-'+equineID).css('display', 'none');
                            $('#canSellHeading-'+equineID).css('display', 'block');
                            $('#selectPicaContainer-'+equineID).css('display', 'block');
                            $('#singlePicaInfo-'+equineID).css('display', 'none');
                        } else {
                            $('.stable-box-primary').LoadingOverlay('hide');
                            $('#remove-pica-failed').modal('show');
                            $('#removePicaFailedMsg').html(response.message);
                        }
                    },
                    error: function( response ) {
                        $('.stable-box-primary').LoadingOverlay('hide');
                        $('#remove-pica-failed').modal('show');
                        $('#removePicaFailedMsg').html(response.message);
                    }
                });
            });
        });
        
    };
    var init = function() {
        bindEvents();
    };
    return {
        init: init
    }
})();

var rvcOptIn = (function() {
    "use strict";
    var bindEvents = function() {
        $('.show-rvc-fom-modal').on('click',function (event) {
            var redirectUrl = event.target.dataset.redirectUrl
            $('#rvc-fom-modal #rvc-modal-no-thanks').attr('data-go-to-url',redirectUrl);
            var findOutMoreButton = $('#rvc-fom-modal #rvc-modal-fom');
            findOutMoreButton.attr('href',encodeURI(findOutMoreButton.data('full-url') + "?redirectUrl=" + redirectUrl));
            $('#rvc-fom-modal').modal('show');
        });

        $('.hide-modal-with-link').on('click', function(e) {
            $(e.target.dataset.id).modal('hide');
        });

        $('#rvc-opt-in').on('change', function (e) {
            if (e.target.checked) {
                $('#rvc-opt-in-submit').removeAttr('disabled');
            } else {
                $('#rvc-opt-in-submit').attr("disabled", true);
            }
        });
    };

    var init = function() {
        bindEvents();
    };

    return {
        init: init
    }
})();

var selectAllCheckboxes = (function() {
    "use strict";
    var bindEvents = function() {
        
        // Object so multiple instances can exist
        var all_selected = {};

        // Generic selector for multiple instances
        $('input[type=checkbox].select-all').on('change', function(e) {

            // Get ID for current instance
            var id = e.target.dataset.id;

            if (id === undefined) {
                console.log('Please add a data attribute to this input.');
                return false;
            }

            all_selected[id] = e.target.checked;

            // Loop through all inputs and set all checked properties to match the select all value
            $('input[type=checkbox][data-id='+id+'].select-all-child').each((k,v) => {
                v.checked = all_selected[id];
            });
        });

        // Generic selector for multiple instances
        $('input[type=checkbox].select-all-child').on('change', (e) => {

            // Get ID for current instance
            var id = e.target.dataset.id;

            if (id === undefined) {
                console.log('Please add a data attribute to this input.');
                return false;
            }

            // Get checked value and the parent select all element
            var checked = e.target.checked
            var parent = $('input[type=checkbox][data-id='+id+'].select-all');

            // If not checked, set select all element to unchecked and update variable
            if (!checked) {
                all_selected[id] = false;
                parent.prop('checked',false);
            } else {
                // If checked, check all other inputs of same id, if any are unchecked, update allChecked to false
                let allChecked = true;
                $('input[type=checkbox][data-id='+id+'].select-all-child').each((k,v) => {
                    if (!v.checked) {
                        allChecked = false;
                    }
                });
                // Set variables and parent select all element to allChecked value
                all_selected[id] = allChecked;
                parent.prop('checked', allChecked);
            }
        });

    };

    var init = function() {
        bindEvents();
    };

    return {
        init: init
    }
})();

function BCP47LanguageCodeToMapboxLanguageCode(languageCode) {
    switch (languageCode) {
        case 'fr-CA':
            return 'fr';
        default:
            return 'en';
    }
}

var movementsMapBox = {
    map: null,
    setMap: (map) => {
        movementsMapBox.map = map;
    },
    createMarker: (lat, lng, destination) => {

        const icon = document.createElement('div');
        icon.className = 'marker';
        icon.style.width = '45px';
        icon.style.height = '50px';
        icon.style.backgroundSize = '100%';
        icon.style.backgroundImage = "url(" + (destination ? '/img/map/green-marker.png' : '/img/map/white-marker.png') + ")";

        // create new map marker
        var marker = new mapboxgl.Marker(icon, {
            offset: [0, -25]
        }).setLngLat([lng,lat]);

        return marker;

    },
    createMap: (elem) => {
        // initialise map instance using current nodes id
        movementsMapBox.map = new mapboxgl.Map({
            container: elem.id,
            style: 'mapbox://styles/mapbox/outdoors-v11',
            language: defaultLanguage === 'en-CA' ? 'en-US' : defaultLanguage,
        })
        
        movementsMapBox.map.addControl(new mapboxLanguage({
            defaultLanguage: BCP47LanguageCodeToMapboxLanguageCode(defaultLanguage === 'en-CA' ? 'en-US' : defaultLanguage),
        }));

        movementsMapBox.map.scrollZoom.disable();

        // Add zoom and rotation controls to the map.
        movementsMapBox.map.addControl(new mapboxgl.NavigationControl());

        return movementsMapBox.map;
    },
    centerMap: (lat, lng) => {
        let lnglat = new mapboxgl.LngLat(lng, lat);
        movementsMapBox.map.setCenter(lnglat);
        movementsMapBox.map.setZoom(16);
    }
}

var movementsA2BLocations= (function() {
    "use strict";

    var movementForm;

    var bindEvents = function(containerID) {
        document.querySelectorAll(`#${containerID} .location-type-input`).forEach((element) => {
            element.addEventListener('change', changeDestinationType);
        });
        $(`#${containerID} .select-box-address`).on('change',updateForm);
        $(`#${containerID} .address-manual-multi input`).on('keyup',updateForm);
        $(`#${containerID} .hidden-multi-address-field`).on('change',updateForm);
        $(`#${containerID} .mapbox-postcode-search button`).on('click', centerMapByPostcode)
    };

    var movementMap = {};

    var changeDestinationType = function (e) {

        $(e.target.dataset.parent + " .panel-collapse").collapse('hide');
        $(e.target.dataset.target).collapse('show');

        if (e.target.value == 'map-selection') {
            if (movementMap.element === undefined) {
                prepareForMap();
            } else {
                movementMap.element.resize();
            }
        }

        updateForm();
    };

    var prepareForMap = function () {

        var storedLat = movementMap.latInput.value;
        var storedLng = movementMap.lngInput.value;

        if (storedLat !== '' && storedLng !== '') {

            if (movementMap.element === undefined) {
                initialiseMap(storedLat, storedLat);
            } else {
                movementsMapBox.centerMap(storedLat, storedLat);
            }

        } else {

            const userAddress = document.querySelector('[name="userAddress"]').value;
            const userPostcode = document.querySelector('[name="userAddressPostcode"]').value;
    
            getGeocode(userAddress, userPostcode, successCallback);
    
            // callback for qeocoder query
            function successCallback (data) {
    
                if (data.coordinates === undefined) return false;
    
                if (movementMap.element === undefined) {
                    initialiseMap(data.coordinates.latitude, data.coordinates.longitude);
                } else {
                    movementsMapBox.centerMap(data.coordinates.latitude, data.coordinates.longitude);
                }
    
                updateForm();
            }
        }
    };

    var initialiseMap = function (lat, lng) {

        var mapElement = document.querySelector('.mapbox-map[data-code="'+movementForm.dataset.field+'"]');

        // initialise map instance using current nodes id
        const map = movementsMapBox.createMap(mapElement);

        movementsMapBox.centerMap(lat, lng);

        var storedLat = movementMap.latInput.value;
        var storedLng = movementMap.lngInput.value;

        if (storedLat !== '' && storedLng !== '') {
            map.on('load', () => {
                addMarkerToMap(storedLat,storedLng);
            });
        }

        // add click event to map instance
        map.on('click', (event) => {
            // populate inputs with the chosen latlng from click event
            movementMap.latInput.value = event.lngLat.lat;
            movementMap.lngInput.value = event.lngLat.lng;
            
            addMarkerToMap(event.lngLat.lat, event.lngLat.lng);
            updateForm();
        });

        // set new map instance as property using equine's id
        movementMap.element = map;
    }

    var centerMapByPostcode = function () {

        const mapPostcodeInput = document.querySelector(`[name="${movementForm.dataset.field}[map-postcode]"]`);

        getAddresses(826, mapPostcodeInput.value, successCallback);

        // callback for qeocoder query
        function successCallback (data) {

            // center the map instance using data returned from geocoder
            if (data.addresses && data.addresses[0].coords !== undefined) {

                var coords = data.addresses[0].coords;
  
                movementMap.latInput.value = coords.latitude;
                movementMap.lngInput.value = coords.longitude;

                if (movementMap.element === undefined) {
                    initialiseMap(coords.latitude,coords.longitude);
                } else {
                    addMarkerToMap(coords.latitude,coords.longitude);
                }
                
                updateForm();
            }
        }
    };

    var addMarkerToMap = function (lat,lng) {

        // create new map marker
        var marker = movementsMapBox.createMarker(lat,lng,true);

        // add marker to map
        marker.addTo(movementMap.element);

        // if more than one marker exists for this map instance, remove the first
        if (movementMap.marker !== undefined) {
            movementMap.marker.remove();
        }
        
        // set new marker instance as property using equine's id
        movementMap.marker = marker;

        movementsMapBox.centerMap(lat, lng);
    }

    var checkFormIsReadyToSubmit = function () {

        var isReady = true;

        var selectionInput = document.querySelector('[name="'+movementForm.dataset.field+'[selection]"]:checked');

        if (selectionInput === null) return false;

        switch (selectionInput.value) {
            case 'map-selection':
                let lat = movementMap.latInput;
                let lng = movementMap.lngInput;
                
                if (lat.value == '' || lng.value == '') {
                    isReady = false;
                }
            break;
            case 'postcode-lookup':
                let country = document.querySelector('[name="'+movementForm.dataset.field+'[country]"]').value;

                let address = document.querySelector('[name="'+movementForm.dataset.field+'[address]"]').value;
                let addressLine1 = document.querySelector('[name="'+movementForm.dataset.field+'[addressLine1]"]').value;
                let county = document.querySelector('[name="'+movementForm.dataset.field+'[county]"]').value;
                let postTown = document.querySelector('[name="'+movementForm.dataset.field+'[postTown]"]').value;
                let postcode = document.querySelector('[name="'+movementForm.dataset.field+'[postcode]"]').value;

                let addressLine1Manual = document.querySelector('[name="'+movementForm.dataset.field+'[addressLine1-manual]"]').value;
                let countyManual = document.querySelector('[name="'+movementForm.dataset.field+'[county-manual]"]').value;
                let postTownManual = document.querySelector('[name="'+movementForm.dataset.field+'[postTown-manual]"]').value;
                let postcodeManual = document.querySelector('[name="'+movementForm.dataset.field+'[postcode-manual]"]').value;

                if ((country == '' || postcode == '' || address == '' || addressLine1 == '' || county == '' || postTown == '') && (postcodeManual == '' || addressLine1Manual == '' || countyManual == '' || postTownManual == '')) {
                    isReady = false;
                }
            break;
        }

        return isReady;
    };

    var updateForm = function () {
        var formIsReady = checkFormIsReadyToSubmit();

        if (formIsReady) {
            return $('#'+movementForm.dataset.field+'-submit').removeAttr('disabled');
        } else {
            return $('#'+movementForm.dataset.field+'-submit').attr('disabled',true);
        }
    };

    var init = function() {
        movementForm = document.querySelector('form[data-id="movement-location-form"');

        if (movementForm !== null) {

            bindEvents(movementForm.id);

            movementMap.latInput = document.querySelector('[name="'+movementForm.dataset.field+'[lat]"]');
            movementMap.lngInput = document.querySelector('[name="'+movementForm.dataset.field+'[lng]"]');
            
            updateForm();

            let mapInput = document.querySelector('input[name="'+movementForm.dataset.field+'[selection]"][value="map-selection"]:checked');

            if (mapInput !== null) {
                prepareForMap();
            }
        }
    };

    return {
        init: init
    }
})();

var movementsA2BConfirm = (function() {
    "use strict";
    var bindEvents = function() {
        
    };

    var confirmMovementMap = {};

    var buildMovementMap = async function () {

        var mapElement = document.querySelector('.mapbox-map[data-code="confirm-movement"]');

        // initialise map instance using current nodes id
        const map = movementsMapBox.createMap(mapElement);

        // set new map instance as property using equine's id
        confirmMovementMap.element = map;

        map.on('load', mapLoadedEvent);

        var markerInputKeys = [];
        // Get all values for marker key inputs and store 
        document.querySelectorAll('input[name="markerInputKeys[]"]').forEach((element, key) => {
            markerInputKeys.push(element.value);
        });

        /**
         * Loop through marker input keys and get location types, then process
         * based on type
         */
        for (let markerInputKey of markerInputKeys) {
            let locationType = document.querySelector('[name="locationType['+markerInputKey+']"]').value;
            let destination = markerInputKey == 'destination';

            switch (locationType) {
                case 'home-location':
                case 'map-selection': 
                    let lat = document.querySelector('[name="lat['+markerInputKey+']"]');
                    let lng = document.querySelector('[name="lng['+markerInputKey+']"]');
                    await buildMarker(lat.value,lng.value, destination);
                break;
                case 'postcode-lookup':
                    let postcode = document.querySelector('[name="postcode['+markerInputKey+']"]');
                    let address = document.querySelector('[name="addressLine1['+markerInputKey+']"]');
                    await dropMarkerByAddress(address.value, postcode.value, destination);
                break;
            }
        }

        mapLoadedEvent();
    };

    var mapLoadedEvent = () => {

        if (confirmMovementMap.departureMarker !== undefined && confirmMovementMap.destinationMarker !== undefined) {
            let markers = [
                confirmMovementMap.departureMarker.getLngLat(),
                confirmMovementMap.destinationMarker.getLngLat()
            ];

            let routeData = [];

            getMapboxDirections(confirmMovementMap.departureMarker.getLngLat(), confirmMovementMap.destinationMarker.getLngLat(), (data) => {

                if (data.routes !== undefined && data.routes.length > 0) {
                    let route = data.routes[0];

                    if (route.legs !== undefined && route.legs.length > 0) {

                        for (let l = 0; l < route.legs.length; l++) {
                            let leg = route.legs[l];

                            for (let s = 0; s < leg.steps.length; s++) {
                                let step = leg.steps[s];

                                for (let i = 0; i < step.intersections.length; i++) {

                                    routeData.push(step.intersections[i].location);
                                }
                            }
                        }
                    }
                }

                confirmMovementMap.element.addSource('route', {
                    'type': 'geojson',
                    'data': {
                        'type': 'Feature',
                        'properties': {},
                        'geometry': {
                            'type': 'LineString',
                            'coordinates': routeData
                        }
                    }
                });
                confirmMovementMap.element.addLayer({
                    'id': 'route',
                    'type': 'line',
                    'source': 'route',
                    'layout': {
                        'line-join': 'round',
                        'line-cap': 'round'
                    },
                    'paint': {
                        'line-color': '#5f9fed',
                        'line-width': 3
                    }
                });

            });
 
            confirmMovementMap.element.fitBounds(markers, {
                padding: 50
            });
        }
    };

    var dropMarkerByAddress = function (address, postcode, destination = false) {

        return new Promise ((resolve, reject) => {

            getGeocode(address,postcode,(data) => {
                if (data.coordinates !== undefined) {
                    resolve(buildMarker(data.coordinates.latitude, data.coordinates.longitude, destination));
                }
            },() => {
                reject(false);
            });
        });
    };

    var buildMarker = function (lat,lng, destination = false) {

        return new Promise ((resolve) => {

            // create new map marker
            var marker = movementsMapBox.createMarker(lat,lng,destination);

            // add marker to map
            marker.addTo(confirmMovementMap.element);

            if (destination) {
                confirmMovementMap.destinationMarker = marker;
            } else {
                confirmMovementMap.departureMarker = marker;
            }

            resolve(true);
        });

    };

    var init = function() {
        if ($('#movement-record-confirm').length > 0) {
            bindEvents();
            buildMovementMap();
        }
    };

    return {
        init: init
    }
})();


var movementsA2BView = (function() {
    "use strict";
    var bindEvents = function() {
        
    };

    var viewMovementMap = {};

    var buildMovementMap = async function () {

        var mapElement = document.querySelector('.mapbox-map[data-code="view-movement"]');

        // initialise map instance using current nodes id
        const map = movementsMapBox.createMap(mapElement);

        // set new map instance as property using equine's id
        viewMovementMap.element = map;

        var markerInputKeys = [
            'source',
            'destination'
        ];

        /**
         * Loop through marker input keys and get location types, then process
         * based on type
         */
        for (let markerInputKey of markerInputKeys) {
            let locationType = document.querySelector('[name="locationType['+markerInputKey+']"]').value;
            let destination = markerInputKey == 'destination';

            switch (locationType) {
                case 'coords': 
                    let lat = document.querySelector('[name="lat['+markerInputKey+']"]');
                    let lng = document.querySelector('[name="lng['+markerInputKey+']"]');
                    await buildMarker(lat.value,lng.value, destination);
                break;
                case 'location':
                    let addressLine1 = document.querySelector('[name="addressLine1['+markerInputKey+']"]');
                    let addressLine2 = document.querySelector('[name="addressLine2['+markerInputKey+']"]');
                    let addressLine3 = document.querySelector('[name="addressLine3['+markerInputKey+']"]');
                    let addressLine4 = document.querySelector('[name="addressLine4['+markerInputKey+']"]');
                    let addressLine5 = document.querySelector('[name="addressLine5['+markerInputKey+']"]');
                    let addressLine6 = document.querySelector('[name="addressLine6['+markerInputKey+']"]');
                    let countryCode = document.querySelector('[name="countryCode['+markerInputKey+']"]');
                    let county = document.querySelector('[name="county['+markerInputKey+']"]');
                    let postTown = document.querySelector('[name="postTown['+markerInputKey+']"]');
                    let postcode = document.querySelector('[name="postcode['+markerInputKey+']"]');

                    var queryString = '';

                    if (addressLine1.value != '') {
                        queryString += addressLine1.value;
                    }
                    if (addressLine2.value != '') {
                        queryString += ' ' + addressLine2.value;
                    }
                    if (addressLine3.value != '') {
                        queryString += ' ' + addressLine3.value;
                    }
                    if (addressLine4.value != '') {
                        queryString += ' ' + addressLine4.value;
                    }
                    if (addressLine5.value != '') {
                        queryString += ' ' + addressLine5.value;
                    }
                    if (addressLine6.value != '') {
                        queryString += ' ' + addressLine6.value;
                    }
                    if (countryCode.value != '') {
                        queryString += ' ' + countryCode.value;
                    }
                    if (county.value != '') {
                        queryString += ' ' + county.value;
                    }
                    if (postTown.value != '') {
                        queryString += ' ' + postTown.value;
                    }
                    if (postcode.value != '') {
                        queryString += ' ' + postcode.value;
                    }

                    await dropMarkerByAddress(queryString, destination);

                break;
            }
        }

        map.on('load', (event) => {

            if (viewMovementMap.departureMarker !== undefined && viewMovementMap.destinationMarker !== undefined) {
                let markers = [
                    viewMovementMap.departureMarker.getLngLat(),
                    viewMovementMap.destinationMarker.getLngLat()
                ];
    
                let routeData = [];
    
                getMapboxDirections(viewMovementMap.departureMarker.getLngLat(), viewMovementMap.destinationMarker.getLngLat(), (data) => {
                    
                    if (data.routes !== undefined && data.routes.length > 0) {
                        let route = data.routes[0];
    
                        if (route.legs !== undefined && route.legs.length > 0) {
    
                            for (let l = 0; l < route.legs.length; l++) {
                                let leg = route.legs[l];
    
                                for (let s = 0; s < leg.steps.length; s++) {
                                    let step = leg.steps[s];
    
                                    for (let i = 0; i < step.intersections.length; i++) {
    
                                        routeData.push(step.intersections[i].location);
                                    }
                                }
                            }
                        }
                    }
    
                    map.addSource('route', {
                        'type': 'geojson',
                        'data': {
                            'type': 'Feature',
                            'properties': {},
                            'geometry': {
                                'type': 'LineString',
                                'coordinates': routeData
                            }
                        }
                    });
                    map.addLayer({
                        'id': 'route',
                        'type': 'line',
                        'source': 'route',
                        'layout': {
                            'line-join': 'round',
                            'line-cap': 'round'
                        },
                        'paint': {
                            'line-color': '#5f9fed',
                            'line-width': 3
                        }
                    });
    
                });
    
                
                viewMovementMap.element.fitBounds(markers, {
                    padding: 50
                });
            }
        });
    };

    var dropMarkerByAddress = function (queryString, destination = false) {

        return new Promise ((resolve, reject) => {

            // get an instance of mapbox geocoder
            var geocoder = L.mapbox.geocoder('mapbox.places');
    
            // Query the geocoder for the user address's latlng 
            geocoder.query(queryString, processResult);
    
            // callback for qeocoder query
            function processResult (err,data) {
    
                if (err !== null) {
                    reject(false);
                }
    
                // center the map instance using data returned from geocoder
                if (data.latlng) {
                    resolve(buildMarker(data.latlng[0],data.latlng[1], destination));
                }
            }
        });
    };

    var buildMarker = function (lat,lng, destination = false) {

        return new Promise ((resolve) => {

            // create new map marker
            var marker = movementsMapBox.createMarker(lat,lng,destination);

            // add marker to map
            marker.addTo(viewMovementMap.element);
    
            if (destination) {
                viewMovementMap.destinationMarker = marker;
            } else {
                viewMovementMap.departureMarker = marker;
            }

            resolve(true);
        });

    };

    var init = function() {
        if ($('#movement-record-view').length > 0) {
            bindEvents();
            buildMovementMap();
        }
    };

    return {
        init: init
    }
})();

var equineLocations = (function() {

    "use strict";

    var bindEvents = function() {
        
    };

    var initialiseMap = function (lat, lng) {

        var mapElement = document.getElementById('equine-location-view');

        // initialise map instance using current nodes id
        const map = movementsMapBox.createMap(mapElement);

        movementsMapBox.centerMap(lat, lng);

        if (lat !== '' && lng !== '') {
            map.on('load', () => {
                // create new map marker
                var marker = movementsMapBox.createMarker(lat,lng,true);
                // add marker to map
                marker.addTo(map.element);

                map.marker = marker;

                movementsMapBox.centerMap(lat, lng);
            });
        }
        map.element = map;
    }

    var init = function() {
        if ($('#equine-location-view').length > 0) {
            bindEvents();
            var lat = $('#equine-location-view').data().lat;
            var lng = $('#equine-location-view').data().long;
            if (lat !== '' && lng !== '') {
                initialiseMap(lat, lng);
            }
        }
    };

    return {
        init: init
    }

})();

var updateEquineLocations = (function() {

    "use strict";

    var init = function() {
        if ($('.equine-location-map-container').length > 0) {
            const mapContainers = document.querySelectorAll('.equine-location-map-container');
            mapContainers.forEach(container => {
                const map = new mapboxgl.Map({
                    container: container.id,
                    style: 'mapbox://styles/mapbox/outdoors-v11',
                    language: defaultLanguage === 'en-CA' ? 'en-US' : defaultLanguage,
                    center: [parseFloat($(container).data().long), parseFloat($(container).data().lat)],
                    zoom :10,
                });
                var lat = $(container).data().lat;
                var lng = $(container).data().long;
                var marker = movementsMapBox.createMarker(lat,lng,true);
                marker.addTo(map);
                map.marker = marker;
                map.on('click', function(e) {
                    const clickedCoordinates = e.lngLat;
                    marker.setLngLat(clickedCoordinates);
                    $('#locationLat').val(clickedCoordinates.lat);
                    $('#locationLong').val(clickedCoordinates.lng);
                });
            });
        }

        if ($('#locationAddress').length > 0) {

            // Load the Google Maps JavaScript API
            loader.load().then((google) => {
                if(google.maps.places) {

                    let placeSelected = false;
                    // Initialize the autocomplete service
                    const autocompleteService = new google.maps.places.AutocompleteService();

                    // Generate a single session token for the session
                    const sessionToken = new google.maps.places.AutocompleteSessionToken();

                    // Set up autocomplete input field
                    const inputField = document.querySelector("#locationAddress");
                    const locationAddress = new google.maps.places.Autocomplete(inputField);

                    const selectedAddress = document.getElementById("selectedAddress");
                    const addressText = document.getElementById("addressText");
                    const editAddress = document.getElementById("editAddress");
                    const barnNameInput = document.getElementById('barnName');
                    const barnAddressContinue = document.getElementById('barnAddressContinue');
                    const barnAddressConfirm = document.getElementById('barnAddressConfirm');
                    const barnAddressCancel = document.getElementById('barnAddressCancel');
                    const barnLocationPanel = document.getElementById('barnLocation');
                    const equineBarnLocationMap = document.getElementById('equine-barn-location');
                    const barnDetails = document.getElementById('barnDetails');
                    const barnEmailInput = document.getElementById('barnEmail');
                    const locationFrm = document.getElementById('locationFrm');

                    barnAddressContinue.disabled = true;
                    barnAddressCancel.style.display = 'none';

                    locationAddress.setOptions({
                        sessionToken: sessionToken,
                        types: ["address"],
                        componentRestrictions: { country: ["ca", "us"] }, // Restrict to selected country
                    });

                    // Add event listener for place changed event
                    locationAddress.addListener("place_changed", () => {
                        const place = locationAddress.getPlace();
                        showAddress(place);
                        placeSelected = true;
                        validateInputs();
                    });

                    barnNameInput.addEventListener('input', validateInputs);
                    barnEmailInput.addEventListener('input', validateInputs);

                    inputField.addEventListener("blur", () => {
                        setTimeout(() => {
                        if (!placeSelected && inputField.value.trim() !== "") {
                            // Get the predictions and select the first one if available
                            autocompleteService.getPlacePredictions(
                                { input: inputField.value, sessionToken: sessionToken },
                                (predictions, status) => {
                                    if (status === google.maps.places.PlacesServiceStatus.OK && predictions && predictions.length > 0) {
                                        const firstPrediction = predictions[0];
                                        const placesService = new google.maps.places.PlacesService(document.createElement('div'));
                                        placesService.getDetails({ placeId: firstPrediction.place_id, sessionToken: sessionToken }, (place, status) => {
                                            if (status === google.maps.places.PlacesServiceStatus.OK) {
                                                showAddress(place);
                                                placeSelected = true;
                                            }
                                            validateInputs();
                                        });
                                    } else {
                                        validateInputs();
                                    }
                                }
                            );
                        } else {
                            validateInputs();
                        }
                        placeSelected = false;
                        }, 200);
                    });

                    editAddress.addEventListener("click", (event) => {
                        event.preventDefault();
                        validateInputs();
                        showInputField();
                    });

                    barnAddressContinue.addEventListener('click', () => {
                        barnLocationPanel.querySelectorAll('.form-group').forEach(group => {
                            group.style.display = 'none';
                        });
                        barnAddressContinue.style.display = 'none';
                        barnAddressConfirm.style.display = 'block';
                        barnAddressCancel.style.display = 'block';
                        equineBarnLocationMap.style.display = 'block';
                        $('#barnDetailName').text(barnNameInput.value);
                        $('#barnDetailAddress').text(addressText.textContent);
                        $('#barnDetailEmail').text($('#barnEmail').val());
                        barnDetails.style.display = 'block';
                    });

                    barnAddressCancel.addEventListener('click', () => {
                        barnLocationPanel.querySelectorAll('.form-group').forEach(group => {
                            group.style.display = 'block';
                        });
                        barnAddressContinue.style.display = 'inline-block';
                        barnAddressConfirm.style.display = 'none';
                        barnAddressCancel.style.display = 'none';
                        equineBarnLocationMap.style.display = 'none';
                        barnDetails.style.display = 'none';
                    });

                    function showAddress(address) {
                        inputField.style.display = "none";
                        addressText.textContent = address.formatted_address;
                        selectedAddress.style.display = "block";
                        const lat = address.geometry.location.lat();
                        const lng = address.geometry.location.lng();
                        $('#locationLat').val(lat);
                        $('#locationLong').val(lng);
                        if (equineBarnLocationMap) {
                            const map = new mapboxgl.Map({
                                container: 'equine-barn-location',
                                style: 'mapbox://styles/mapbox/outdoors-v11',
                                language: defaultLanguage === 'en-CA' ? 'en-US' : defaultLanguage,
                                center: [lng, lat],
                                zoom: 10,
                            });
                            const marker = movementsMapBox.createMarker(lat, lng, true);
                                marker.addTo(map);
                                map.marker = marker;
                                map.on('click', function(e) {
                                    const clickedCoordinates = e.lngLat;
                                    marker.setLngLat(clickedCoordinates);
                                    $('#locationLat').val(clickedCoordinates.lat);
                                    $('#locationLong').val(clickedCoordinates.lng);
                                });
                        }
                    }

                    function showInputField() {
                        inputField.value = addressText.textContent;
                        inputField.style.display = "block";
                        selectedAddress.style.display = "none";
                    }

                    function validateInputs() {
                        const barnNameFilled = barnNameInput.value.trim() !== '';
                        const emailValid = validateEmail(barnEmailInput.value);
                        const emailFilled = barnEmailInput.value.trim() === '' || emailValid;
                        barnAddressContinue.disabled = !(barnNameFilled && placeSelected && emailFilled);
                        if (!emailValid && barnEmailInput.value.trim() !== '') {
                            barnEmailInput.closest('.form-group').classList.add('form-group-error');
                        } else {
                            barnEmailInput.closest('.form-group').classList.remove('form-group-error');
                        }
                    }

                    function validateEmail(email) {
                        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        return emailPattern.test(email);
                    }

                    $('.locationFrmSubmit').on('click', function() {
                        locationFrm.submit();
                    });
                    
                } else {
                    console.log('Error loading Google Maps Places API');
                }
            }).catch((error) => {
                console.log(error);
            });
        }
    };

    return {
        init: init
    }

})();

var addressLookupMulti = (function () {
    "use strict";

    var dataKey = false;
    var addressesFound = null;

    var bindEvents = function() {
        $('.find-address').on('click', doLookup);
        $('.manual-address').on('click', manualAddress);
        $('.postcode-lookup').on('click', postcodeLookup);
        $('.select-box-address').on('change', populateAddressPieceInputs);
    };

    var populateAddressPieceInputs = function (e) {
        let address = addressesFound[e.target.value];
        let field = e.target.dataset.field;
        let key = e.target.dataset.key;

        if (address !== undefined) {
            for (let addressMapLine in address.addressLinesMap) {
                var input = document.querySelector(`[name="${field}[${addressMapLine}]"][data-key="${key}"]`);
                input.value = address.addressLinesMap[addressMapLine];
                $(input).trigger('change');
            }
        }
    };

    var postcodeLookup = function(e) {
        e.preventDefault();

        const key = e.target.dataset.key;
        dataKey = `[data-key=${key}]`;

        $('textarea.manual-address-field'+dataKey).val('');
        $('input.postcode-manual'+dataKey).val('');
        $('.address-lookup'+dataKey).slideDown();
        $('.address-manual-multi'+dataKey).slideUp();
        $('#btn-add-address').attr("disabled", "disabled");
    };

    var manualAddress = function(e) {
        e.preventDefault();

        const key = e.target.dataset.key;
        dataKey = `[data-key=${key}]`;

        $('.address-not-found'+dataKey).slideUp();
        $('input.postcode'+dataKey).val('');
        $('.select-box-address'+dataKey)
            .find('option')
            .remove();
        $('.address-list-select'+dataKey).slideUp();
        $('.address-lookup'+dataKey).slideUp();
        $('.address-manual-multi'+dataKey).slideDown();
        $('#btn-add-address').attr("disabled", "disabled");
    };

    var doLookup = function(e) {
        e.preventDefault();

        const key = e.target.dataset.key;
        dataKey = `[data-key=${key}]`;

        $('.address-not-found').fadeOut();
        
        var postcode = $(this).closest('form').find('input.postcode'+dataKey).val().replace(/ +/g, '');
        var country = $(this).closest('form').find('select.select-box-country'+dataKey).val().replace(/ +/g, '');
        $(this).closest('div.input-group').removeClass('form-group-error');
        if (!postcode) {
            $(this).closest('div.input-group').addClass('form-group-error');
        } else {
            $('.address-loader'+dataKey).LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
            $('.select-box-address'+dataKey)
                .find('option')
                .remove();

            var api = {
                endpoint: '/ajax/utils/' + postcode + '/' + country + '/address'
            };
            $.getJSON(api.endpoint)
                .then(renderAddresses)
                .catch(handleError);
        }
    };

    var renderAddresses = function(response) {

        if (response.addresses && response.count > 0) {

            addressesFound = response.addresses;

            $('.select-box-address'+dataKey).append($('<option>', {
                value: '',
                text: 'Please Select',
                disabled: true,
                selected: true,
            }));
            $.each(addressesFound, function (index, value) {
                $('.select-box-address'+dataKey).append($('<option>', {
                    value: index,
                    text: value['address']
                }));
            });
            $('.address-loader'+dataKey).LoadingOverlay('hide');
            $('.address-list-select'+dataKey).fadeIn();
        } else {
            $('.address-list-select'+dataKey).hide();
            $('.address-loader'+dataKey).LoadingOverlay('hide');
            $(this).closest('div.form-control').addClass('form-group-error');
            $('.address-not-found'+dataKey).fadeIn();
        }
    };

    // handle errors
    function handleError(err) {
        $('.address-list-select'+dataKey).hide();
        $('.address-loader'+dataKey).LoadingOverlay('hide');
        $(this).closest('div.form-control').addClass('form-group-error');
        $('.address-not-found'+dataKey).fadeIn();
    }

    var init = function() {

        var manualAddresses = document.querySelectorAll('.address-manual-multi');
        if (manualAddresses !== null) {
            manualAddresses.forEach((elem,key) => {
                let iKey = elem.dataset.key;
                let address = document.querySelector('.select-box-address[data-key="'+iKey+'"]');
                let addressManual = document.querySelector('.manual-address-field[data-key="'+iKey+'"]');
                if (address.value || addressManual.value == '') {
                    elem.style.display = 'none';
                } else if (address.value == '' || !address.value) {
                    document.querySelector('.address-lookup[data-key="'+iKey+'"]').style.display = 'none';
                } else {
                    elem.style.display = 'none';
                }
            });
        }

        // .hide();
        $('#btn-add-address').attr("disabled", "disabled");
        bindEvents();
    };
    return {
        init: init
    }
})();

function getMapboxDirections (source, destination, then, err = null) {

    var api = {
        endpoint: `https://api.mapbox.com/directions/v5/mapbox/driving/${source.lng},${source.lat};${destination.lng},${destination.lat}?access_token=${mapboxgl.accessToken}&steps=true`
    };

    $.getJSON(api.endpoint).then(then).catch(err == null ? (error) => { } : err);
}

function getGeocode (address, postcode, then, err = null) {

    var api = {
        endpoint: '/ajax/utils/' + address + '/' + postcode + '/geocode'
    };

    $.getJSON(api.endpoint).then(then).catch(err == null ? (error) => { } : err);
}

function getAddresses (country = 826, postcode, then, err = null) {

    var api = {
        endpoint: '/ajax/utils/' + postcode + '/' + country + '/address'
    };

    $.getJSON(api.endpoint).then(then).catch(err == null ? (error) => { } : err);
}

function allEquines() {
    if ( ! $.fn.DataTable.isDataTable( '#allEquines' ) ) {
        var allEquines = $('#allEquines').dataTable({
            "searching": true,
            "processing": true,
            "responsive": true,
            "serverSide": true,
            "ordering": false,
            "fixedHeader ": true,
            "autoWidth": false,
            "ajax": "/equines/all",
            "dom": "<'row'<'col-sm-6 col-md-4'f><'col-sm-1 col-md-2 col-xs-12 clear-filter'><'col-sm-5 col-md-6'l>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row'<'col-sm-6'i><'col-sm-6'p>>",
            "language": {
                "search": '<div class="input-group"><input class="form-control" type="text" id=""><span class="input-group-btn"><button class="btn btn-primary btn-table-search" type="button"><i class="fa fa-search"></i> '+translations.table_search_button+'</button></span></div>',
                "lengthMenu": '<label>'+translations.table_show_label+' </label> _MENU_ <label>'+translations.table_per_page_label+'</label> ',
                "searchPlaceholder": $('#allEquines').data().placeholder,
                "processing": '<i style="color: #006760;" class="fa fa-circle-notch fa-spin fa-4x"></i><span class="sr-only">Loading...</span> ',
                "info": translations.table_info_show_label+" _START_ "+translations.table_info_to_label+" _END_ "+translations.table_info_of_label+" _TOTAL_ "+translations.table_info_entries_label,
                "paginate": {
                    "previous": translations.table_previous_link,
                    "next": translations.table_next_link
                },
                "emptyTable": translations.table_equine_empty
            },
            "aLengthMenu": [5, 10, 25],
            "pageLength": 10,
            "initComplete": function(settings, json) {
                $('#allEquines_filter input').unbind();
                $('#allEquines_filter input').bind('keyup', function(e) {
                    if(e.keyCode === 13) {
                        allEquines.fnFilter(this.value);
                        $('.clear-filter').each(function () {
                            $(this).empty();
                            if(this.value != '') {
                                $(this).append('<a class="btn-link clear-filter-btn  btn">'+translations.table_clear_link+'</a>');
                            }
                        });
                    }
                });
                $('.btn-table-search').on('click', function(e) {
                    allEquines.fnFilter($('#allEquines_filter input').val());
                    $('.clear-filter').each(function () {
                        $(this).empty();
                        if($('#allEquines_filter input').val() != '') {
                            $(this).append('<a class="btn-link clear-filter-btn  btn">'+translations.table_clear_link+'</a>');
                        }
                    });
                });
            },
            "columnDefs": [
                { className: "middle hidden-sm hidden-xs hidden-md", targets: [3]},
                { className: "middle hidden-sm hidden-xs", targets: [3, 4]},
                { className: "middle", targets: "_all"}
            ],
            "createdRow": function( row, data, dataIndex ) {
                $(row).addClass( data.status );
            },
            "columns": [
                { "data": "image" },
                {
                    "data": "name",
                    "render": function(data, type, row) {
                        if (type === 'display' && data.length > 35) {
                            return data.substr(0, 35) + '...';
                        } else {
                            return data;
                        }
                    }
                },
                { "data": "ueln" },
                { "data": "studbook" },
                { "data": "equines" }
            ]
        });
    }
}

function createSelectElementFromArray (id, name, classes, options) {
    var select = document.createElement('select');
    select.id = id;
    select.name = name;
    select.className = classes;
    for (let i in options) {
        let option = document.createElement('option');
        option.value = i;
        option.innerHTML = options[i];
        select.appendChild(option);
    }
    return select;
}

function allMovements() {
    if ( ! $.fn.DataTable.isDataTable( '#allMovements' ) ) {
        var orderByConfig = {
            id: "allMovementsOrderBy",
            name: "orderBy",
            classes: "",
            options: {
                'created': translations.movements_list_last_created,
                'departure': translations.movements_list_departure
            }
        };

        var allMovements = $('#allMovements').DataTable({
            "searching": false,
            "processing": true,
            "serverSide": true,
            "ordering": false,
            "ajax": {
                url: "/equine/movements/all",
                data: (d) => {
                    document.querySelectorAll('.filtering-elements select').forEach((v,k) => {
                        d[v.name] = v.value;
                    });
                }
            },
            "dom": "<'row'<'col-sm-6 filtering-elements'f><'col-sm-6'l>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row'<'col-sm-6'i><'col-sm-6'p>>",
            "language": {
                "lengthMenu": '<label>'+translations.movements_list_show+' </label> _MENU_ <label>'+translations.movements_list_per_page+'</label> ',
                "processing": '<i style="color: #006760;" class="fa fa-circle-notch fa-spin fa-4x"></i><span class="sr-only">'+translations.movements_list_loading+'..n.</span> ',
                "zeroRecords": translations.movements_list_zero_movement_plans_recorded,
                "info": translations.table_info_show_label+" _START_ "+translations.table_info_to_label+" _END_ "+translations.table_info_of_label+" _TOTAL_ "+translations.table_info_entries_label,
                "paginate": {
                    "previous": translations.table_previous_link,
                    "next": translations.table_next_link
                }
            },
            "aLengthMenu": [5, 10],
            "pageLength": 10,
            "initComplete": function() {
                var orderByContainer = document.createElement('div');
                orderByContainer.innerHTML = translations.movements_list_sort+': ';
                orderByContainer.appendChild(createSelectElementFromArray(
                    orderByConfig.id, 
                    orderByConfig.name, 
                    orderByConfig.classes, 
                    orderByConfig.options
                ));
                orderByContainer.addEventListener('change', (event) => {
                    allMovements.ajax.reload(null, true);
                });
                document.querySelector('div.filtering-elements').appendChild(orderByContainer);
            },
            "columns": [
                { "data": "data" },
            ]
        });
        
    }
}

function findClosestParentWithClass(element, classname, depth) {
    if (element.classList.contains(classname)) {
        element.classList.remove(classname);
        return true;
    }
    if (depth <= 10) {
        depth++;
        return findClosestParentWithClass(element.parentElement, classname, depth);
    } else {
        return false;
    }
}

// Disables a button on click. If the button is a submit button, it will submit the form.
// This is useful for preventing double form submissions.
// The manual form submission is necessary because the button is disabled and the form will not submit.
function disableThisOnClick(event) {
    event.target.disabled = true;
    if (event.target.type === 'submit') {
        event.target.form.submit();
    }
}

$(document).ready(function(){

    if ($('#region-search').length > 0) {
        var regionSearch = $('#region-search');

        document.querySelector('#country').addEventListener('change', function(){
            var country = this.value;
            
            var countryRegions = regions.filter(function(region){
                return region.countryCode == country;
            });
    
            regionSearch.typeahead('destroy');
            regionSearch.typeahead({
                source: countryRegions,
                minLength: 1,
                fitToElement: true,
                afterSelect: function(data){
    
                    var exists = false;
                    document.querySelectorAll('[name="region[]"]').forEach(function(element){
                        if(element.value == data.id){
                            alert('Region already selected');
                            exists = true;
                            return;
                        }
                    });
        
                    if(exists){
                        return;
                    }
        
                    var multipleChoice = document.createElement('div');
                    multipleChoice.classList.add('multiple-choice');
        
                    var elemID = 'region-' + data.id;
        
                    var input = document.createElement('input');
                    input.name = 'region[]';
                    input.value = data.id;
                    input.type = 'checkbox';
                    input.id = elemID;
                    input.checked = true;
                    
                    var label = document.createElement('label');
                    label.innerHTML = data.name;
                    label.htmlFor = elemID;
        
                    multipleChoice.appendChild(input);
                    multipleChoice.appendChild(label);
        
                    document.getElementById('region-group').querySelector('fieldset').appendChild(multipleChoice);
                    document.getElementById('region-group').style.display = 'block';
                    document.getElementById('confirm-region').disabled = false;
                    document.querySelector(typeaheadSelector).value = '';
                }
            }).on('change', () => {});
    
            document.getElementById('region-search-container').style.display = 'block';
        });
    }


    // This method will clear the etag from the session once we've handed 
    // it off to the React side of the application. This is necessary to
    // prevent the etag from being used in the next request.
    $(document).on('click', 'a.clear-query-param-session', function(e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var paramGroup = $(this).data('param-group');
        $.ajax({
            url: '/ajax/session/clear?param-group=' + paramGroup,
            type: 'GET',
            success: function() {
                console.log('ETag cleared from session');
                window.location.href = url;
            },
            error: function(e) {
                console.log('Error clearing ETag from session');
                window.location.href = url;
            }
        });
    })

    document.querySelectorAll('.disable-this-on-click').forEach((elem) => elem.addEventListener('click', disableThisOnClick));

    $(document).on('click', '.show-live-chat', function() {
        window.Intercom('show');
    });

    var uri = window.location.toString();
    if (uri.indexOf("?") > 0) {
        var clean_uri = uri.substring(0, uri.indexOf("?"));
        window.history.replaceState({}, document.title, clean_uri);
    }

    var labels = document.querySelectorAll('.multiple-choice>label')
    labels.forEach((label) => {
        var input = label.parentNode.querySelector('input[type="checkbox"]');
        if (input) {
            label.addEventListener('click', () => {
                if (input.disabled) {
                    return;
                }
                input.checked = !input.checked;
                const e = new Event('change');
                input.dispatchEvent(e);
            });
        }
    });

    $('.input-group.date-input').each(function() {
        var opts = {
            format: "dd/mm/yyyy",
            autoclose: true,
            todayHighlight: true,
        };
        switch ($(this).data('selection-window')) {
            case 'past':
                opts['endDate'] = '0d';
                break;
            case 'future':
                opts['startDate'] = '0d';
                break;
        }
        $(this).datepicker(opts).on('changeDate', function(e){
            "use strict";
            var date = e.date;
            e.target.parentNode.querySelector('[name*="-day"]').value = date.getDate();
            e.target.parentNode.querySelector('[name*="-month"]').value = date.getMonth()+1;
            e.target.parentNode.querySelector('[name*="-year"]').value = date.getFullYear();
        });
    });

    $('input.typeahead').typeahead({
        source: function (query, process) {
            return $.ajax({
                url: '/ajax/lookup/vet-practice',
                data: {search: query},
                dataType: 'json'
            })
            .done(function(response) {
                return process(response.data);
            });
        },
        minLength: 3,
        afterSelect: function (data) {
            $('#practice_id').val(data.id);
        }
    });

    if($('#studbook-search').length > 0) {
        $('input.studbook-search').typeahead({
            source: studbooks,
            minLength: 1,
            fitToElement: true,
            afterSelect: function (data) {
                $('#studbookID').val(data.uuid);
                $('#studbookName').val(data.name);
                $('#studbookSubmit').removeAttr('disabled');
            }
        }).on('change', function() {
            $('#studbookSubmit').attr('disabled', 'disabled');
          });
    }

    if($('#studbook-search').length > 0) {
        $('input.studbook-search').typeahead({
            source: studbooks,
            minLength: 1,
            fitToElement: true,
            afterSelect: function (data) {
                $('#studbookID').val(data.uuid);
                $('#studbookName').val(data.name);
                $('#studbookSubmit').removeAttr('disabled');
            }
        }).on('change', function() {
            $('#studbookSubmit').attr('disabled', 'disabled');
          });
    }
    if ($('.multiple-choice.with-panel').length > 0) {
        $('.multiple-choice.with-panel').on('change','input[type=radio]',(e) => {
            var input = e.target;
            if (input.dataset.target !== undefined && input.dataset.parent !== undefined) {
                $(e.target.dataset.parent + ' .panel-collapse[data-parent="'+e.target.dataset.parent+'"]').collapse('hide');
                $(e.target.dataset.target).collapse('show');
            }
        });
    }

    $('.link-with-loading-overlay').on('click',function(e) {
        $('.stable-box').LoadingOverlay('show', {image : "", fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
    });

    $('.form-group-error input, .form-group-error textarea, .form-group-error select').bind('keyup click change', (event) => {
        findClosestParentWithClass(event.currentTarget,"form-group-error",1);
    });

    $('#remove-access #confirm-remove-access').on('click', function() {
        $('#remove-access').modal('hide');
    });

    $('.remove-user-request').on('click', (event) => {
        var id = event.target.dataset.id;
        var name = event.target.dataset.name;
        var equine = event.target.dataset.equine;

        $('#remove-access-request .fill-name').html(name);
        $('#remove-access-request .fill-equine').html(equine);
        $('#remove-access-request #confirm-remove-access-request').attr("href", "/request/"+ id+"/remove");

        $('#remove-access-request').modal('show');
    });

    $('#remove-access-request #confirm-remove-access-request').on('click', function() {
        $('#remove-access-request').modal('hide');
    });
    

    $('#autoMatchModal').modal('show');

    if($('#upload-image').length > 0) {
        var $uploadCrop;
		function readFile(input) {
 			if (input.files && input.files[0]) {
	            var reader = new FileReader();
	            reader.onload = function (e) {
					$('.upload-image').addClass('ready');
	            	$uploadCrop.croppie('bind', {
	            		url: e.target.result
	            	});
	            }
	            reader.readAsDataURL(input.files[0]);
	        } else {
		        console.log("Sorry - you're browser doesn't support the FileReader API");
		    }
		}

		$uploadCrop = $('#upload-image').croppie({
			viewport: {
				width: 300,
				height: 357
			},
            boundary: {
                width: 300,
                height: 357
            },
            enforceBoundary: false,
			enableExif: true,
            showZoomer: false
		});

        $uploadCrop.croppie('bind', '/img/stable/no-horse-image.png').then(function(){ 
            $uploadCrop.croppie('setZoom', 1)
        });

		$('#equineImage').on('change', function (e) { 
            e.preventDefault();
            readFile(this); 
            $('.cr-slider').show();
            $('#uploadImageBtn').removeAttr('disabled');
        });
		$('#uploadImageBtn').on('click', function (ev) {
            ev.preventDefault();
			$uploadCrop.croppie('result', {
				type: 'canvas',
				size: 'viewport'
			}).then(function (resp) {
				$('#imagebase64').val(resp);
                $('#crop-image-form').submit();
			});
		});
    }

    $('#cedMatches').DataTable({
        "searching": false,
        "language": {
            "lengthMenu": '<label>'+translations.table_show_label+' </label> _MENU_ <label>'+translations.table_per_page_label+'</label> ',
            "info": translations.table_info_show_label+" _START_ "+translations.table_info_to_label+" _END_ "+translations.table_info_of_label+" _TOTAL_ "+translations.table_info_entries_label,
            "paginate": {
                "previous": translations.table_previous_link,
                "next": translations.table_next_link
            }
        },
    });

    $('.input-group.generic-date').datepicker({
        format: "dd/mm/yyyy",
        autoclose: true,
        todayHighlight: true,
    }).on('changeDate', function(e){
        "use strict";
        var code = $(this).data('code');
        var date = e.date;
        $('#' + code + '-day').val(date.getDate());
        $('#' + code + '-month').val(date.getMonth()+1);
        $('#' + code + '-year').val(date.getFullYear());
    });

    $('.form-date .generic-date-part').on('keyup', function(e){
        "use strict";
        var dateParts = {};
        var code = $(this).data('code');

        $('.form-date .generic-date-part[data-code="'+code+'"]').each(function(k,v) {
            var part = $(this).attr('name').replace(code + "-", "");
            dateParts[part] = v.value;
        });

        if (dateParts.day === undefined || dateParts.month === undefined || dateParts.year === undefined) {
            console.log('Please make sure all date parts are present and have the correct data-code.');
            return false;
        }

        $(`input[name=${code}-date]`).val(`${dateParts.day}/${dateParts.month}/${dateParts.year}`);
    });

    $('.input-group.vaccination-date').datepicker({
        format: "dd/mm/yyyy",
        autoclose: true,
        todayHighlight: true,
        endDate: '0d'
    }).on('changeDate', function(e){
        "use strict";
        var code = $(this).data('vaccination-code');
        var date = e.date;
        $('#' + code + '-day').val(date.getDate());
        $('#' + code + '-month').val(date.getMonth()+1);
        $('#' + code + '-year').val(date.getFullYear());
        $('#submit').removeAttr('disabled');
    });

    $('.input-group.deceased-date').datepicker({
        format: "dd/mm/yyyy",
        autoclose: true,
        todayHighlight: true,
        endDate: '0d'
    }).on('changeDate', function(e){
        "use strict";
        var code = $(this).data('deceased-code');
        var date = e.date;
        $('#' + code + '-day').val(date.getDate());
        $('#' + code + '-month').val(date.getMonth()+1);
        $('#' + code + '-year').val(date.getFullYear());
        $('#submit').removeAttr('disabled');
    });

    $('.input-group.missing-date').datepicker({
        format: "dd/mm/yyyy",
        autoclose: true,
        todayHighlight: true,
        endDate: '0d'
    }).on('changeDate', function(e){
        "use strict";
        var code = $(this).data('missing-code');
        var date = e.date;
        $('#' + code + '-day').val(date.getDate());
        $('#' + code + '-month').val(date.getMonth()+1);
        $('#' + code + '-year').val(date.getFullYear());
        $('#submit').removeAttr('disabled');
    });

    $('.js-hidden').each(function(){
        "use strict";
        $(this).hide();
    });

    $('.input-group.sold-date').datepicker({
        format: "dd/mm/yyyy",
        autoclose: true,
        todayHighlight: true,
        endDate: '0d'
    }).on('changeDate', function(e){
        "use strict";
        var code = $(this).data('sold-code');
        var date = e.date;
        $('#' + code + '-day').val(date.getDate());
        $('#' + code + '-month').val(date.getMonth()+1);
        $('#' + code + '-year').val(date.getFullYear());
        $('#submit').removeAttr('disabled');
    });

    $('.js-hidden').each(function(){
        "use strict";
        $(this).hide();
    });

    $('label.terms').click(function(event) {
        if (event.target.tagName !== 'A') {
            var checkboxId = $(this).attr('for');
            var checkbox = $('#' + checkboxId);
            checkbox.prop('checked', !checkbox.prop('checked')).change();
        }
    });
    
    $('#search-type input[type=radio]').on('click', function(e) {
        "use strict";
        var type = $(this).val();
        $('.js-hidden').slideUp();
        $('#' + type + '-input').slideDown();
        $('#search').removeAttr('disabled');

        $('#' + type + '-input').find('input[type=text]').filter(':first').focus();

    });

    $('.form-submit-overlay').submit(function(e) {
        $('.stable-box').LoadingOverlay('show', {image : "", fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
    });

    $('.link-click-overlay').on('click', function(e) {
        $('.stable-box').LoadingOverlay('show', {image : "", fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
    });

    $('.open-menu').on('click', function() {
        $('.overlay').addClass('open');
        $('.open-menu').hide();
    });

    $('.close-menu').on('click', function() {
        $('.overlay').removeClass('open');
        $('.open-menu').show();
    });
    $('.open-manage-menu').on('click', function() {
        $('.manage-overlay').addClass('open');
    });

    $('.close-manage-menu,.show-rvc-fom-modal').on('click', function() {
        $('.manage-overlay').removeClass('open');
        $('.open-manage-menu').show();
    });

    $('#death-date-unknown').on('click', function(e) {
        $('input[name=death-date-unknown]').val('true');
        $('#death-date-section').slideUp();
        $('#show-death-date').parent().slideDown();
    });
    $('#show-death-date').on('click', function(e) {
        $('input[name=death-date-unknown]').val('false');
        $('#death-date-section').slideDown();
        $('#show-death-date').parent().slideUp();
    });

    $(document).on('click', '.data-dismissed-component', function() {
        var componentId = $(this).data('dismissed-component-id');
        $.ajax({
            type: "POST",
            url    : "/ajax/user/set-user-interface-dismissed-components",
            data   : {id: componentId},
            success: function( response ) {

            }
        });
    });

    $(document).on('click', '#btnUpdateConfirm', function() {
        $('#updateConfirm').val('1');
        $('#myModal').modal('hide');
        $('#updateEquineDetailsForm').submit();
    });

    $(document).on('click', '.languageSwitcher', function() {
        var langId = $(this).data().id;
        $('#languageSwitcher').val(langId);
        $('#languageSwitcherFrm').trigger("submit");
    });

    $(document).on('change', '#selectPreferredLanguage', function() {
        $('.overlay-loader-target').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
        $('#selectPreferredLanguageForm').trigger("submit");
    });

    $(document).on('submit', '#singleRiderForm', function(e) {
        var error = false;
        $('#riderAlert').addClass('hidden');
        $('.equine-rider').closest('.form-group').removeClass('form-group-error');
        $('.form-group-error').removeClass('form-group-error');
        if ($('.equine-rider:checked').length == 0) {
            $('.equine-rider').closest('.form-group').addClass('form-group-error');
            error = true;
        }
        if($('.equine-rider:checked').val() == 'rider') {

            if($('#rider-details-firstname').val() == ''){
                $('#rider-details-firstname').closest('.form-group').addClass('form-group-error');
                error = true;
            }
            if($('#rider-details-surname').val() == ''){
                $('#rider-details-surname').closest('.form-group').addClass('form-group-error');
                error = true;
            }
            if($('#dob-day').val() == ''){
                $('#rider-details-dob').addClass('form-group-error');
                error = true;
            }
            if($('#dob-month').val() == ''){
                $('#rider-details-dob').addClass('form-group-error');
                error = true;
            }
            if($('#dob-year').val() == ''){
                $('#rider-details-dob').addClass('form-group-error');
                error = true;
            }
        }
        if(error) {
            $('#riderAlert').html('Please resolve the errors below.');
            $('#riderAlert').removeClass('hidden');
            $('.singleRiderSubmit').html('Submit rider details');
            e.preventDefault();
        }
    });

    $(document).on('submit', '#frmVehicle', function(e) {
        var error = false;
        $('#riderAlert').addClass('hidden');
        $('.form-group-error').removeClass('form-group-error');
        $('.vehicle-reg').each(function(i, obj) {
            if($(obj).val() == '' || $(obj).val() == null){
                $(obj).closest('.form-group').addClass('form-group-error');
                error = true;
            }
        });

        if(error) {
            $('#riderAlert').html('Please resolve the errors below.');
            $('#riderAlert').removeClass('hidden');
            $('.frmVehicleSubmit').html('Submit &amp; Continue <i class="fa fa-angle-right"></i>');
            e.preventDefault();
        }

    });

    $(document).on('submit', '#frmVehicleAllocation', function(e) {
        var error = false;
        $('#riderAlert').addClass('hidden');
        $('.form-group-error').removeClass('form-group-error');
        $('.vehicle-option').each(function(i, obj) {
            if(!$(obj).hasClass('equine-selected')){
                error = true;
            }
        });

        if(error) {
            $('.riders-toggle-1').trigger('click');
            $('#riderAlert').html('Please select the horses to allocate in vehicles.');
            $('#riderAlert').removeClass('hidden');
            $('.frmVehicleSubmit').html('Confirm &amp; Continue <i class="fa fa-angle-right"></i>');
            e.preventDefault();
        }
    });


    $(document).on('click', '.vehicle-option', function(e) {
        var val = $(this).val();
        if($(this).prop("checked") == true){
            $('.vehicle-option-'+val).attr("disabled", true);
            $('.vehicle-option-'+val).attr('checked','checked');
            $(this).removeAttr("disabled");
            $('.vehicle-option-'+val).addClass("equine-selected");
        }
        else if($(this).prop("checked") == false){
            $('.vehicle-option-'+val).removeAttr("disabled");
            $('.vehicle-option-'+val).removeAttr('checked');
            $('.vehicle-option-'+val).removeClass("equine-selected");
        }
    });

    $(document).on('change', '.location-country-select', function(e) {
        var val = $(this).val();
        if(val != 826) {
            $('#date-of-arrival').slideUp();
        }  else {
            $('#date-of-arrival').slideDown();
        }
    });

    $(document).on('change', '#date-from-birth', function(e) {
        if($('#date-from-birth').is(':checked') === true) {
            $('#doa-day').val($(this).data('day'));
            $('#doa-month').val($(this).data('month'));
            $('#doa-year').val($(this).data('year'));
        } else {
            $('#doa-day').val('');
            $('#doa-month').val('');
            $('#doa-year').val('');
        }
    });

    if ($('#allEquines').length > 0) {
        allEquines();
    }
    allMovements();
    $(document).on('click', 'a.location-toggle', function() {
	    $(this).find('[class*="angle"]').toggleClass('fa-angle-down fa-angle-up');
    });
    $(document).on('click', 'a.riders-toggle', function() {
        $(this).find('[class*="angle"]').toggleClass('fa-angle-down fa-angle-up');
    });

    $(document).on('click', 'a.panel-toggle', function() {
        $(this).find('[class*="angle"]').toggleClass('fa-angle-down fa-angle-up');
    });

    $('.collapse').on('show.bs.collapse', function (e) {
        // Get clicked element that initiated the collapse...
    });

    $.fn.dataTable.ext.errMode = function (settings, tn, msg) {
        if (settings && settings.jqXHR && settings.jqXHR.status == 401) {
            window.location.href = '/user/logout';
            return;
        } 
    };

    $(document).on('click', '.clear-filter-btn', function() {
        $('#allEquines_filter input').val('');
        $('.btn-table-search').trigger('click');
    });

    $(document).on('click', '.clear-ced-sync-filter-btn', function() {
        $('#changeOwnershipTable_filter input').val('');
        $('.btn-ced-sync-search').trigger('click');
    });

    $(document).on('click', '.hovereffect', function() {
        $('#imageModal').modal('show');
    });

    $(document).on('click', '.documentImage', function() {
            var angle = ($(this).data('angle') + 90) || 90;
            $(this).css({'transform': 'rotate(' + angle + 'deg)'});
            $(this).css({'margin-top': '100px'});
            $(this).data('angle', angle);
    });
    
    $(document).on('click', '#displayHandler', function() {
        var state = $('#displayHandler').data().hidden;
        if(state == 0) {
            $('.branchResultHidden').removeClass('hidden');
            $('#displayHandler').html('Hide other branches');
            $('#displayHandler').data('hidden', 1);
        } else {
            $('.branchResultHidden').addClass('hidden');
            $('#displayHandler').html('Show more branches');
            $('#displayHandler').data('hidden', 0);
        }
    });

    $(document).on('click', '#branchSearch', function() {
        var postcode = $('#branchPostcode').val();
        var api = {
            endpoint: '/ajax/utils/'+postcode+'/branch'
        };
        $('.stable-box').LoadingOverlay('show', {image : "", fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
        $.getJSON(api.endpoint).then(function(data) {
            $('#branchResultsList').empty();
            var cordinates = [];
            var addressDetails = [];
            if(data.length > 0) {
                $.each(data, function (i, currAddress) {
                    var address = [];
                    $.each(currAddress, function (key, val) {
                        if(key == 'address') {
                            var fullAddress = Object.values(currAddress.address);
                            address = fullAddress.splice(0,fullAddress.length - 2);
                            cordinates.push(fullAddress.reverse());
                            addressDetails.push(currAddress);
                        }
                    });
                    
                    var newElement = $('.branchResultItem').clone();
                    $(newElement).removeClass('hidden');
                    $(newElement).removeClass('branchResultItem');
                    $(newElement).addClass('branchResult');
                    
                    $(newElement).find('.branchName').html(currAddress.name)
                    $(newElement).find('.branchResultsAddress').html(address.join(', '));
                    $(newElement).find('.branchId').val(currAddress.locationBusinessId);
                    $(newElement).find('.branchId').attr('id', 'branch_id_'+currAddress.locationBusinessId);
                    $(newElement).find('.branchDetails').attr('for', 'branch_id_'+currAddress.locationBusinessId);
                    $(newElement).find('.brancNumber').html(i + 1);
                    if(i > 2) {
                        $(newElement).addClass('branchResultHidden hidden');
                        $('#displayHandler').html('Show more branches');
                    }
                    $('#branchResultsList').append(newElement);
                });

                const map = new mapboxgl.Map({
                    container: 'branchMap',
                    style: 'mapbox://styles/mapbox/outdoors-v11',
                    center: cordinates[0],
                    zoom :10,
                    language: defaultLanguage === 'en-CA' ? 'en-US' : defaultLanguage,
                });

                    cordinates.forEach(function(cordinate, i) {
                        var fullAddress = Object.values(addressDetails[i].address);
                        var address = fullAddress.splice(0,fullAddress.length - 2);
                        var el = document.createElement('div');
                        el.className = 'marker';
                        el.innerHTML = '<span><b>' + (i + 1) + '</b></span>'
                        new mapboxgl.Marker(el)
                            .setLngLat(cordinate)
                            .setPopup(new mapboxgl.Popup({
                                offset: 25
                              }) 
                              .setHTML('<p class="branchTitle">'+addressDetails[i].name+'</p><p class="branchAddress">'+address.join(', ')+'</p>'))
                            .addTo(map);
                    });
                }
                $('.stable-box').LoadingOverlay('hide');
          });
    });

    $(document).on('click', '.microchipSearchOption', function() {
        $('#microchipSearch').val($('#microchipSearch').val().replace(/\s/g, ""));

        if ($('#microchipSearch').val().length > 14 && $('#microchipSearch').val().length < 16) {
            $('#microchip-search-container').removeClass('form-group-error');
            $('#microchip-feedback').css('display', 'none');
            $('#microchipSearchBtn').removeAttr('disabled');
        } else {
            $('#microchipSearchBtn').attr('disabled', 'disabled');
        }
    });

    $(document).on('click', '.uelnSearchOption', function() {
        $('#uelnSearch').val($('#uelnSearch').val().replace(/\s/g, ""));
        if ($('#uelnSearch').val().length > 0) {
            $('#uelnSearchBtn').removeAttr('disabled');
        } else {
            $('#uelnSearchBtn').attr('disabled', 'disabled');
        }
    });

    if ($('.uelnExist').length > 0) {
        $('#uelnSearch').val($('#uelnSearch').val().replace(/\s/g, ""));
        if ($('#uelnSearch').val().length > 0) {
            $('#uelnSearchBtn').removeAttr('disabled');
        } else {
            $('#uelnSearchBtn').attr('disabled', 'disabled');
        }
    }
});

function setCookieConsent(marketing, performance) {
    var domain = '';
    var date = new Date(Date.now() + 30 * 86400e3);
    var expires = date.toUTCString();
    var hostname = window.location.hostname;
    var parts = hostname.split('.');
    var mainDomain = parts.slice(-2).join('.');
    var subDomain = parts.slice(1, -2).join('.');
    domain = subDomain ? '.' + subDomain + '.' + mainDomain : '.' + mainDomain;

    document.cookie =
      'cookieConsent={"marketing":"' + (marketing ? 'granted' : 'denied') + '","performance":"' + (performance ? 'granted' : 'denied') + '"}; expires=' +
      expires +
      '; path=/; domain=' +
      domain +
      '; secure; SameSite=Strict';
      
  
    gtag('consent', 'update', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'granted',
      marketing_storage: marketing ? 'granted' : 'denied',
      performance_storage: performance ? 'granted' : 'denied'
    });
  
    dataLayer.push({
      event: 'consentChanged'
    });
  }
  
  function getCookieConsent(){
    var cookie_consents = getCookie('cookieConsent');

    if(cookie_consents !== null){
        cookie_consents = JSON.parse(cookie_consents);
    }

    return cookie_consents;
  }

  function getCookie(name) {
      var value = `; ${document.cookie}`;
      var parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      else return null;
    }
  
    window.onload = function() {
        // Show the cookie consent banner if the consent cookie is not set and the user is not on the cookies page
        if (getCookie('cookieConsent') === null && window.location.href.indexOf('/user/cookies') === -1) {
            var cookieBanner = document.getElementById('cookie_consent_popup');
            if (cookieBanner !== null) cookieBanner.classList.add('show');
        }
    
        // Define the consent form handler
        var consentFormHandler = {
            init: function() {
                var updateCookiesButton = document.getElementById('updateCookiesButton');
                if (updateCookiesButton) {
                    updateCookiesButton.addEventListener('click', function(event) {
                        event.preventDefault(); // Prevent the form from submitting normally
    
                        var marketing = document.querySelector('input[name="marketing"]').checked;
                        var performance = document.querySelector('input[name="performance"]').checked;
    
                        // Set the cookie and update gtag
                        setCookieConsent(marketing, performance);
                        hideCookieBanner();
    
                        // Hide the cookie banner
                        document.getElementById('cookie_consent_popup').style.display = 'none';
    
                        // Submit the form
                        event.target.form.submit();
                    });
    
                    // Pre-fill the form based on the existing cookie consents
                    var cookie_consents = getCookieConsent() || {};
                    document.querySelector('input[name="marketing"]').checked = cookie_consents['marketing'] === 'granted';
                    document.querySelector('input[name="performance"]').checked = cookie_consents['performance'] === 'granted';
                }
            }
        };
    
        // Initialize the consent form handler if the button exists
        consentFormHandler.init();
    };
  
  $('#cookieAccept').on('click', function() {
    // Grant all consent when cookieAccept is clicked
    setCookieConsent(true, true);
    hideCookieBanner();
  });
  
  function hideCookieBanner() {
      var cookieBanner = document.getElementById('cookie_consent_popup');
      if (cookieBanner !== null) cookieBanner.classList.remove('show');
  }

  function scrollToHash() {
    var hash = window.location.hash.substr(1);
    if (hash) {
        var target = document.getElementById(hash);
        if (target) {
            setTimeout(function() {
                target.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    }
}


document.addEventListener("DOMContentLoaded", function() {
    // Triggers an event in GTM when the user begins the checkout process for a subscription
    function beginCheckout() {
        if (typeof window.dataLayer !== 'undefined' && window.dataLayer.push) {
            window.dataLayer.push({
                'event': 'begin_checkout',
                'item_id': 'subscription',
                'item_name': 'Subscription'
            }); 
        } else {
            console.warn('dataLayer is not defined.');
        }
    }

    // Triggers an event in GTM when the user successfully subscribes
    function subscriptionSuccess() {
        if (typeof window.dataLayer !== 'undefined' && window.dataLayer.push) {
            window.dataLayer.push({
                'event': 'purchase',                                                                                                            
                'currency':'CAD',
                'value': '9.99',
                'user_email_address': userEmail
            }); 
        } else {
            console.warn('dataLayer is not defined.');
        }
    }

    // Make the functions globally accessible
    window.beginCheckout = beginCheckout;
    window.subscriptionSuccess = subscriptionSuccess;
});

document.addEventListener('DOMContentLoaded', function() {
    scrollToHash();
});

var handleFormChange = (function() {
    var bindEvents = function() {

        var formElementOriginalValues = {};
        var formElementNewValues = {};

        function seeIfChanged () {

            var changed = false;

            $.each(formElementNewValues, (k, v) => {
                if (v != formElementOriginalValues[k]) {
                    changed = true;
                }
            });

            return changed;

        }

        $('.handle-form-change input').each((k,v) => {
            formElementOriginalValues[v.name] = v.value;
            formElementNewValues[v.name] = v.value;
        });

        $('.handle-form-change input').on('keyup', (event) => {

            var newValue = event.target.value;
            var field = event.target.name;

            formElementNewValues[field] = newValue;

            var submit = $('.handle-form-change button[type=submit]');

            if (!submit.attr('data-is-disabled')) {
                $('.handle-form-change button[type=submit]').attr("disabled",!seeIfChanged());
            }
        });

        if ($('#branchSearch').length > 0) {
            $('#branchSearch').trigger('click');
        }

    };
    var init = function() {
        bindEvents();
    };
    return {
        init: init
    }
})();

var previousOwnerSelect = (function () {
        "use strict";
    
        var bindEvents = function() {
            if($('#radio-inline-1').is(':checked') === true) {
                $('#radio-inline-1').trigger('click');
            }
    
        };
    
        var init = function() {
            bindEvents();
        };
    
        return {
            init: init
        }
})();

var fetchNotitifcation = (function () {
    "use strict";

    var bindEvents = function() {
        if ($('.notification-bar').length > 0) {
            $.getJSON("/notifications/count", function(result){
                if(result.count > 0){
                    $('.notification-bar').removeClass('hidden');
                    $('.notification-count').html(result.count);
                }
            });
        }
    };

    var init = function() {
        bindEvents();
    };

    return {
        init: init
    }
})();

var autoCompleteAddressLookup = (function () {
    "use strict";

    var bindEvents = function() {
        if ($('#autoCompleteAddress').length > 0) {
                let originalValues = {
                    address_line_1: $('#address_line_1').val(),
                    address_line_2: $('#address_line_2').val(),
                    address_line_3: $('#address_line_3').val(),
                    city: $('#city').val(),
                    county: $('#county').val(),
                    postalcode: $('#postalcode').val()
                };
                $('#manualAddressEntry').on('click', function(e) {
                    $('#address-fields').slideDown();
                    $('#manualAddressEntry').hide();
                    document.querySelector("#address_line_1").focus();
                    validateAddress();
                });

                function validateAddress () {
                    if(
                        ($('input[name=postcode-manual]').val() != '') ||
                        (
                            $('input[name="manual[address_line_1]"]').val() != '' && $('input[name="manual[address_line_1]"]').val() != undefined 
                            && $('input[name="manual[address_line_4]"]').val() != '' && $('input[name="manual[address_line_4]"]').val() != undefined 
                            && $('input[name=postcode-manual]').val() != ''
                        )
                    ) {
                        $('#btn-add-address').removeAttr('disabled');
                    } else {
                        $('#btn-add-address').attr("disabled", "disabled");
                    }
                }

                // Load the Google Maps JavaScript API
                loader.load().then((google) => {
                    if(google.maps.places) {

                        // Initialize the autocomplete service
                        const autocompleteService = new google.maps.places.AutocompleteService();

                        // Generate a single session token for the session
                        const sessionToken = new google.maps.places.AutocompleteSessionToken();

                        // Set up autocomplete input field
                        const inputField = document.querySelector("#autoCompleteAddress");
                        const autocomplete = new google.maps.places.Autocomplete(inputField);

                        // Attach a session token to the autocomplete request
                        function updateCountryRestriction(countryCode) {
                            var countySelect = document.getElementById('county');
                            var regions = JSON.parse(regionList);
                            if (regions[countryCode]) {
                                countySelect.innerHTML = '';
                                regions[countryCode].forEach(function(region) {
                                    var option = document.createElement('option');
                                    option.value = region.name;
                                    option.textContent = region.name;
                                    countySelect.appendChild(option);
                                });
                            }
                            autocomplete.setOptions({
                                sessionToken: sessionToken,
                                types: ["address"],
                                componentRestrictions: { country: [countryCode] }, // Restrict to selected country
                            });
                            inputField.parentElement.parentElement.style.display = "block";
                        }

                        function getRegionName(countryCode, regionCode) {
                            var regions = JSON.parse(regionList);
                            if (regions[countryCode]) {
                                for (var i = 0; i < regions[countryCode].length; i++) {
                                    if (regions[countryCode][i].code === regionCode) {
                                        return regions[countryCode][i].name;
                                    }
                                }
                            }
                            return null; // If not found, return null
                        }

                        // Add event listener for place changed event
                        autocomplete.addListener("place_changed", () => {
                            const place = autocomplete.getPlace();
                            // Parse the selected place into address fields
                            parseAddress(place);
                            // Clear the autocomplete field
                            inputField.value = "";
                            // Show address fields
                            $('#manualAddressEntry').trigger('click');
                            // Focus on first line of address
                            document.querySelector("#address_line_1").focus();
                            // Validate address
                            validateAddress();
                        });

                        // Function to parse the selected place into address fields
                        function parseAddress(place) {
                            const addressComponents = place.address_components;
                            const address = {};
                            var countryCode = document.querySelector("#select-box-country").value;
                            addressComponents.forEach((component) => {
                                switch (component.types[0]) {
                                case "street_number":
                                    address.address_line_1 = component.long_name;
                                    break;
                                case "route":
                                    address.address_line_2 = component.long_name;
                                    break;
                                case "sublocality_level_1":
                                case "neighborhood":
                                    address.address_line_3 = component.long_name;
                                    break;
                                case "locality":
                                    address.town = component.long_name;
                                    break;
                                case "administrative_area_level_1":
                                    address.county = getRegionName(countryCode, component.short_name)
                                    break;
                                case "postal_code":
                                    address.postalcode = component.long_name;
                                    break;
                                default:
                                    // Other types can be handled similarly
                                    break;
                                }
                            });
                            // Populate address fields
                            document.querySelector("#address_line_1").value = address.address_line_1 || "";
                            document.querySelector("#address_line_2").value = address.address_line_2 || "";
                            document.querySelector("#address_line_3").value = address.address_line_3 || "";
                            document.querySelector("#city").value = address.town || "";
                            document.querySelector("#county").value = address.county || "";
                            document.querySelector("#postalcode").value = address.postalcode || ""; 
                            document.querySelector("#address-lookup-lat").value = place.geometry.location.lat(); 
                            document.querySelector("#address-lookup-long").value = place.geometry.location.lng(); 
                            document.querySelector("#address-lookup-changed").value = "false";

                            originalValues = {
                                address_line_1: $('#address_line_1').val(),
                                address_line_2: $('#address_line_2').val(),
                                address_line_3: $('#address_line_3').val(),
                                city: $('#city').val(),
                                county: $('#county').val(),
                                postalcode: $('#postalcode').val()
                            };
                        }

                        // Add event listener for country change
                        var countrySelector = document.querySelector("#select-box-country");
                        if(countrySelector) {
                            // Function to handle country change
                            function handleCountryChange() {
                                const countryCode = countrySelector.value;
                                if (countryCode) {
                                    updateCountryRestriction(countryCode);
                                }
                            }
                            countrySelector.addEventListener("change", handleCountryChange);
                            handleCountryChange();
                        }
                    } else {
                        document.querySelector("#address-lookup-changed").value = "true";
                        console.log('Error loading Google Maps Places API');
                    }
                }).catch((error) => {
                    document.querySelector("#address-lookup-changed").value = "true";
                });

                function checkAllValuesMatchOriginal() {
                    for (const key in originalValues) {
                      if ($('#' + key).val() !== originalValues[key]) {
                        return false;
                      }
                    }
                    return true;
                  }
                
                function handleInputChange() {
                    const inputId = $(this).attr('id');
                    const newValue = $(this).val();
                    if (checkAllValuesMatchOriginal()) {
                      document.querySelector("#address-lookup-changed").value = "false";
                    } else {
                        document.querySelector("#address-lookup-changed").value = "true";
                    }
                }

                $('#address_line_1, #address_line_2, #address_line_3, #city, #county, #postalcode').on('input', handleInputChange);
        }
    };

    var init = function() {
        bindEvents();
    };

    return {
        init: init
    }
})();

var uelnSearchBtn = (function () {
    "use strict";

    var bindEvents = function() {
        if ($('#uelnSearchBtn').length > 0 || $('#tempSearchBtn').length > 0) {
            function nextDigit(input, cursorpos, isBackspace) {
                if (isBackspace){
                    for (let i = cursorpos-1; i > 0; i--) {
                        if(/\w/.test(input[i])){
                            return i
                        }
                    }
                }else{
                    for (let i = cursorpos-1; i < input.length; i++) {
                        if(/\w/.test(input[i])){
                            return i
                        }
                    }
                }
                return cursorpos
            }

            function patternMatch({input,template}) {
                try {
                  let j = 0;
                  let plaintext = "";
                  let countj = 0;
                  while (j < template.length) {                    
                    if (countj > input.length - 1) {
                        template = template.substring(0, j);
                        break;
                    }
                    if (template[j] == input[j]) {
                        j++;
                        countj++;
                        continue;
                    }
              
                    if (template[j] == "x") {
                        template = template.substring(0, j) + input[countj] + template.substring(j + 1);
                        plaintext = plaintext + input[countj];
                        countj++;
                    }
                        j++;
                  }
                  return template
                } catch {
                    return ""
                }
            }
            var uelnSearchXHR;
            $('#uelnSearch').on('input', function(e) {
                if (uelnSearchXHR != null && 'abort' in uelnSearchXHR) {
                    uelnSearchXHR.abort();
                }
                const uelnSearch = document.getElementById("uelnSearch");
                let cursorPos = e.target.selectionStart;
                let currentValue = e.target.value;
                let cleanValue = currentValue.replace(/[^a-zA-Z0-9]/g, "");
                let formatInput = patternMatch({
                    input: cleanValue,
                    template: "xxx xxxx xxxx xxxx"
                });
                e.target.value = formatInput;
                let isBackspace = (e && e.data === null) ? true : false;
                let nextCusPos = nextDigit(formatInput, cursorPos, isBackspace);
                uelnSearch.setSelectionRange(nextCusPos+1, nextCusPos+1);

                let search = $(this).val().replace(/\s/g, "");
                if ($('#validateUeln').length > 0) {

                    var invalidUELN = function(feedbackElemID) {
                        $('.ueln-feedback').css('display', 'none');
                        if (feedbackElemID !== false) {
                            $('#ueln-search-container').addClass('form-group-error');
                            $(feedbackElemID).css('display', 'block');
                        } else {
                            $('#ueln-search-container').removeClass('form-group-error');
                        }
                        $('#uelnSearchBtn').attr('disabled', 'disabled');
                    }

                    var validUELN = function(){ 
                        $('#ueln-search-container').removeClass('form-group-error');
                        $('.ueln-feedback').css('display', 'none');
                        $('#uelnSearchBtn').removeAttr('disabled');
                    }

                    var isInvalidCountryCode = function(ueln) {
                        return countryCodes.indexOf(search.slice(0, 3)) === -1
                    }

                    let sLen = search.length;
                    switch (true) {
                    case sLen < 3:
                        return invalidUELN(false);
                    case 3 <= sLen && sLen < 6:
                        if (isInvalidCountryCode(search)) {
                            return invalidUELN('#ueln-feedback-country');
                        }
                        return invalidUELN(false);
                    case 6 <= sLen:
                        let invalidCountryCode = isInvalidCountryCode(search);
                        if (invalidCountryCode) {   
                            var studbookIdentifier = search.slice(3, 6);
                            const start = 3;
                            let end = start + studbookUELNIdentifiers.length;

                            // Check if the studbook identifier is invalid
                            let invalidStudbook = studbookUELNIdentifiers.find(function (elem) {
                                return String(elem).slice(start, end) === studbookIdentifier
                            }) == undefined;

                            if (!invalidStudbook) {
                                return invalidUELN('#ueln-feedback-country');
                            } else {
                                return invalidUELN('#ueln-feedback-country-and-studbook');
                            }
                        } else {
                            if (studbookUELNIdentifiers.indexOf(search.slice(0, 6)) === -1) {
                                return invalidUELN('#ueln-feedback-studbook');
                            }
                        }
                        if (sLen < 15) {
                            return invalidUELN(false);
                        }
                    }
                    validUELN();
                } else {
                    if ($(this).val().length > 0) {
                        $('#uelnSearchBtn').removeAttr('disabled');
                    } else {
                        $('#uelnSearchBtn').attr('disabled', 'disabled');
                    }
                }
            });
            $('#tempSearch').on('keyup', function(e) {
                const tempSearch = document.getElementById("tempSearch");
                let cursorPos = e.target.selectionStart;
                let currentValue = e.target.value;
                let cleanValue = currentValue.replace(/[^a-zA-Z0-9]/g, "");
                let formatInput = patternMatch({
                    input: cleanValue,
                    template: "xxx xxxx xxxx xxxx"
                });
                e.target.value = formatInput;
                let isBackspace = (e && e.data === null) ? true : false;
                let nextCusPos = nextDigit(formatInput, cursorPos, isBackspace);
                tempSearch.setSelectionRange(nextCusPos+1, nextCusPos+1);
                let searchValue = $(this).val().replace(/\s/g, "");
                if ($('#validateTemp').length > 0) {
                    let firstThreeChars = cleanValue.slice(0, 3);
                    let tmpChar = cleanValue.slice(3, 6);
                    if (countryCodes.indexOf(firstThreeChars) >= 0 && tmpChar.toLowerCase() == 'tmp' && searchValue.length > 14 && searchValue.length < 16) {
                        $('#temp-search-container').removeClass('form-group-error');
                        $('#temp-feedback').css('display', 'none');
                        $('#tempSearchBtn').removeAttr('disabled');
                    } else {
                        $('#temp-search-container').addClass('form-group-error');
                        $('#temp-feedback').css('display', 'block');
                        $('#tempSearchBtn').attr('disabled', 'disabled');
                    }
                } else {
                    if ($(this).val().length > 0) {
                        $('#tempSearchBtn').removeAttr('disabled');
                    } else {
                        $('#tempSearchBtn').attr('disabled', 'disabled');
                    }
                }
            });
            $('#alt-pio-name').on('keyup', function(e) {
                $(this).val($(this).val().replace(/\s/g, ""));
                if ($(this).val().length > 0 || $('#pio-list').val().length > 0) {
                    $('#searchConfirm').removeAttr('disabled');
                } else {
                    $('#searchConfirm').attr('disabled', 'disabled');
                }
            });
            $('#pio-list').on('change', function(e) {
                if ($(this).val().length != null || $('#alt-pio-name').val().length > 0) {
                    $('#searchConfirm').removeAttr('disabled');
                } else {
                    $('#searchConfirm').attr('disabled', 'disabled');
                }
            });
            $('#uelnSearchBtn, #tempSearchBtn').on('click', function(e) {
                e.preventDefault();
                $('.universal-checker-wrapper').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
                var search = $('#universal-checker-form  input[name=universal-search]').val();
                var searchType = $('#universal-checker-form  input[name=type]').val();
                var page = $('#universal-checker-form  input[name=page]').val();
                $('#pio-details-section').css('display', 'none');
                $('#pio-list').val(null);
                $('#searchConfirm').attr('disabled', 'disabled');
                $.ajax({
                    url: '/register/lookup/equine-search',
                    type: 'get',
                    contentType: 'application/json',
                    dataType: "json",
                    data: {'search' : search, searchType: searchType, page: page},
                    success: function( data, textStatus, jQxhr ){
                        if(data.found == true) {
                            if(data.count > 1) {
                                $('.universal-checker-wrapper').LoadingOverlay('hide');
                                $('#pio-details-section').css('display', 'block');
                                $('#input-search-type').val('passport');
                                $('.universal-checker-wrapper').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
                                $('#input-search-passport').val(search);
                            } else {
                                location.href='/register/lookup/result';
                            }
                        } else {
                            if(data.add == true) {
                                if(data.page != null && data.page != '') {
                                    location.href='/register/equine/'+data.page+'?'+data.query;
                                } else {
                                    location.href='/register/equine';
                                }
                            } else {
                                if(data.duplicate == true) {
                                    location.href='/register/lookup/result';
                                } else {
                                    if(data.page != null && data.page != '') {
                                        location.href='/register/equine/'+data.page+'?'+data.query;
                                    } else {
                                        location.href='/register/equine';
                                    }
                                }
                            }
                        }
                    },
                    error: function( jqXhr, textStatus, errorThrown ){
                        $('.universal-checker-wrapper').LoadingOverlay('hide');
                        $('#universalCheckerButton').html('<i class="fa fa-search"></i> Search for equine');
                    }
                });
            });
            $('#ueln-search-no').on('click', function(e) {
                $('#uelnSearch').val('');
                $('#ueln-search-container').removeClass('form-group-error');
                $('.ueln-feedback').css('display', 'none');
                $('#uelnSearchBtn').attr('disabled', 'disabled');
            });
        }
    }

    var init = function() {
        bindEvents();
    }

    return {
        init: init
    }
})();

var microchipSearchBtn = (function () {
    "use strict";

    var bindEvents = function() {
        if ($('#microchipSearchBtn').length > 0 || $('#microchip-submit').length > 0) {
            $('#microchipSearch, #microchip-number').on('keyup', function(e) {
                e.target.value = e.target.value.replace(/\s/g, "");
                var len = e.target.value.length;
                switch (true) {
                    case len < 9:
                        $('#microchip-search-container').removeClass('form-group-error');
                        $('#microchip-feedback').css('display', 'none');
                        $('#microchipSearchBtn,#microchip-submit').attr('disabled', 'disabled');
                        break;
                    case len != 9 && len != 10 && len != 15:
                        $('#microchip-search-container').addClass('form-group-error');
                        $('#microchip-feedback').css('display', 'block');
                        $('#microchipSearchBtn,#microchip-submit').attr('disabled', 'disabled');
                        break;
                    default:
                        $('#microchip-search-container').removeClass('form-group-error');
                        $('#microchip-feedback').css('display', 'none');
                        $('#microchipSearchBtn,#microchip-submit').removeAttr('disabled');
                }
            });
            $('#mc-alt-pio-name').on('keyup', function(e) {
                $(this).val($(this).val().replace(/\s/g, ""));
                if ($(this).val().length > 0 || $('#mc-pio-list').val().length > 0) {
                    $('#searchMicrochipConfirm').removeAttr('disabled');
                } else {
                    $('#searchMicrochipConfirm').attr('disabled', 'disabled');
                }
            });
            $('#mc-pio-list').on('change', function(e) {
                if ($(this).val().length != null || $('#mc-alt-pio-name').val().length > 0) {
                    $('#searchMicrochipConfirm').removeAttr('disabled');
                } else {
                    $('#searchMicrochipConfirm').attr('disabled', 'disabled');
                }
            });
            $('#microchipSearchBtn').on('click', function(e) {
                e.preventDefault();
                $('.universal-checker-wrapper').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
                var search = $('#microchip-checker-form  input[name=microchip-search]').val();
                $('#pio-details-section').css('display', 'none');
                $('#mc-pio-list').val(null);
                $('#searchMicrochipConfirm').attr('disabled', 'disabled');
                $.ajax({
                    url: '/register/lookup/microchip-search',
                    type: 'get',
                    contentType: 'application/json',
                    dataType: "json",
                    data: {'search' : search},
                    success: function( data, textStatus, jQxhr ){
                        if(data.found == true) {
                            if(data.count > 1) {
                                $('.universal-checker-wrapper').LoadingOverlay('hide');
                                $('#mc-pio-details-section').css('display', 'block');
                                $('#input-search-type').val('passport');
                                $('.universal-checker-wrapper').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
                                $('#input-search-passport').val(search);
                            } else {
                                location.href='/register/lookup/result';
                            }
                        } else {
                            location.href='/register/equine/other';
                        }
                    },
                    error: function( jqXhr, textStatus, errorThrown ){
                        $('.universal-checker-wrapper').LoadingOverlay('hide');
                        $('#universalCheckerButton').html('<i class="fa fa-search"></i> Search for equine');
                    }
                });
            });
        }
    }

    var init = function() {
        bindEvents();
    }

    return {
        init: init
    }
})();

var membershipSearchBtn = (function () {
    "use strict";

    var bindEvents = function() {
        if ($('#membershipSearchBtn').length > 0) {
            $('#membershipSearch').on('keyup', function(e) {
                $(this).val($(this).val().replace(/\s/g, ""));
                if ($(this).val().length > 0) {
                    $('#membershipSearchBtn').removeAttr('disabled');
                } else {
                    $('#membershipSearchBtn').attr('disabled', 'disabled');
                }
            });
        }
    }

    var init = function() {
        bindEvents();
    }

    return {
        init: init
    }

})();

var ownershipConfirm = (function () {
    "use strict";

    var bindEvents = function() {
        if ($('#ownershipConfirm').length) {
            $('.confirmConsent').on('change', function () {
                var allChecked = $('.confirmConsent:checked').length === $('.confirmConsent').length;
                if (allChecked) {
                    $('#confirm').removeAttr('disabled');
                } else {
                    $('#confirm').attr("disabled", "disabled");
                }
            });
        }
    }

    var init = function() {
        bindEvents();
    }

    return {
        init: init
    }

})();

if ($('#resendCount').length > 0) {

    var currentTime = Math.floor(Date.now() / 1000);
    var elapsedTime = currentTime - startTime;
    var timeLeft = remainingTime - elapsedTime;
    if (timeLeft <= 0) {
        $("#countdown").hide();
        $("#resendCodeLink").show();
    } else {
        var countdownTimer = setInterval(function() {
            timeLeft--;
            $("#resendCount").text(timeLeft);
            if (timeLeft <= 0) {
                clearInterval(countdownTimer);
                $("#countdown").hide();
            $("#resendCodeLink").show();
            }
        }, 1000);
    }
    document.getElementById('resendCodeLink').addEventListener('click', function(e) {
        e.preventDefault();
        document.getElementById('resendCodeFrm').requestSubmit();
    })
}

if ($('.mobile-code-verify').length > 0) {
    var $inputs = $(".mobile-code-verify");
    var intRegex = /^\d+$/;

    function pasteValues(element) {
        var values = element.split("");
    
        $(values).each(function(index) {
            var $inputBox = $('.mobile-code-verify[name="code[' + (index + 1) + ']"]');
            $inputBox.val(values[index])
        });
    };
    
    $inputs.on("input.fromManual", function(){
        if(!intRegex.test($(this).val())){
            $(this).val("");
        }
    });
    $inputs.on("paste", function() {
        var $this = $(this);
        var $currentInputBox;
        var originalValue = $this.val();
        
        $this.val("");
    
        $this.one("input.fromPaste", function(){
            $currentInputBox = $(this);
            var pastedValue = $currentInputBox.val();
            
            if (pastedValue.length == 6 && intRegex.test(pastedValue)) {
                pasteValues(pastedValue);
            }
            else {
                $this.val(originalValue);
            }
    
            $inputs.attr("maxlength", 1);
        });
        
        $inputs.attr("maxlength", 6);
        
    }).on('paste', function() {
        var $this = $(this);
        setTimeout(function() {
            $this.trigger('input');
            var pastedValue = $this.val();
            if (pastedValue.trim() !== '') { 
                $('.mobile-code-verify').last().focus(); 
            }
        }, 50); 
    });
    $('.mobile-code-verify').on('input', function() {
        var allFilled = true;
        if (this.value.length === this.maxLength) {
            let next = $(this).data('next');
            $('#mobile-verify-' + next).focus();
        }
        $('.mobile-code-verify').each(function() {
            if (!$(this).val() || isNaN($(this).val())) {
                allFilled = false;
            }
        });
        if (allFilled) {
            $('#verifySubmitBtn').prop('disabled', false);
        } else {
            $('#verifySubmitBtn').prop('disabled', true);
        }
    });
}

var comingSoonSubscribeForm = (function () {
    "use strict";

    var bindEvents = function() {
        $(document).on('change', '#coming-soon-subscribe-form input[name="marketing_emails"]', function(e) {
            var form = e.target.closest('#coming-soon-subscribe-form');
            if (e.target.checked) {
                form.querySelector('button[type="submit"]').removeAttribute('disabled');
            } else {
                form.querySelector('button[type="submit"]').setAttribute('disabled', true);
            }
        });
    }

    var init = function() {
        var callers = document.getElementsByClassName('coming-soon-modal');
        if (callers.length > 0) {
            bindEvents();
        }
    }

    return {
        init: init
    }
})();

var openPanels = (function () {
    var init = function() {
        // Add other radio names here, if you'd like to expand them on page load, when they are checked
        let radioNames = ['has_id'];
        // Create query string for radio buttons in the list
        let query = radioNames.map(name => `input[type=radio][name=${name}][data-expand-target]:checked`).join(',');

        // Expand all radio buttons (from list) on page load
        let buttons = document.querySelectorAll(query);
        if (buttons) {
            buttons.forEach((elem) => {
                let expand = document.querySelector(`.panel[data-expand-name=${elem.getAttribute('data-expand-target')}]`);
                if (!expand) return;
                if (expand.style.display !== 'none') return;
                elem.click() ;
            });
        }
    }
    return {
        init: init
    }
})();

document.addEventListener('readystatechange', (e) => {
    // Use this state to perform actions when the page is fully loaded;
    // This seems to fire after $(document).ready()
    if (e.target.readyState === 'complete') {
        openPanels.init();
    }
    // ownershipUeln
    if ($('.form-control-clear').length) {
        $('.form-control-clear').on('input', function() {
            var inputValue = $(this).val();
            var sanitizedValue = inputValue.replace(/\s/g, ''); // Remove all spaces
            $(this).val(sanitizedValue);
        });
    }
    
});

var paymentSelectionBtn = (function () {
    "use strict";
    var init = function() {
        $(document).on('click', '.btn-price', function(e) {
            var productID = $(this).data('productid');
            $('#productId').val(productID);

            $('.btn-price').removeClass('btn-selected');
            $(this).addClass('btn-selected');

            $('.price-tab').css('display', 'none');
            $(`.price-tab[data-productid=${productID}]`).css('display', 'block');
        });
    }
    return {
        init: init
    }
})();

var subscriptionPayment = (function() {
    // $('.overlay-loader-target').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
    var setup = function() {
        var stripe = Stripe(stripePublicKey, {
            locale : paymentLocale,
        });
        const options = {
            mode: 'subscription',
            amount: 0,
            currency: 'cad',
            payment_method_configuration: paymentMethodConfiguration
          };

        // Create an instance of Elements.
        var elements = stripe.elements(options);

        // Create an instance of the card Element.
        const paymentElement = elements.create('payment', {
            layout: {
                type: 'tabs',
            },
        });

        paymentElement.on('ready', () => {
            $('.overlay-loader-target').LoadingOverlay('hide');
        })
        paymentElement.mount('#subscription-payment-element');

        // Handle form submission.
        var form = document.getElementById('subscription-payment-form');
        const submitBtn = document.getElementById('subscription-payment-button');

        const handleError = (error) => {
            submitBtn.disabled = false;
            $('.overlay-loader-target').LoadingOverlay('hide');
            const handleErrorDiv = document.getElementById('handleError');
            handleErrorDiv.classList.remove('hidden');
        }

        form.addEventListener('submit', async(event) => {
            // $('.overlay-loader-target').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
            event.preventDefault();
            const handleErrorDiv = document.getElementById('handleError');
            handleErrorDiv.classList.add('hidden');
            if (submitBtn.disabled) {
                return;
            }
            submitBtn.disabled = true;
            try {
                const {error: submitError} = await elements.submit();
                if (submitError) {
                    handleError(submitError);
                    return;
                }

                const res = await fetch('/subscribe/create', {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ product_id: $('#productId').val() })
                });

                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                const responseData = await res.json();
                if (responseData.error) {
                    throw new Error(responseData.error);
                }
                const {type, customer_secret} = responseData;
                const confirmIntent = type === "setup" ? stripe.confirmSetup : stripe.confirmPayment;
                const {error} = await confirmIntent({
                    elements,
                    clientSecret: customer_secret,
                    confirmParams: {
                    return_url: paymentSuccessUrl,
                    },
                });

                if (error) {
                    handleError(error);
                } else {
                    console.log('Payment successful');
                }
            } catch (error) {
                handleError(error);
            } finally {
                $('.overlay-loader-target').LoadingOverlay('hide');
            }
        });

    };
    var init = function() {
        if ($('#subscription-payment-form').length) {
            setup();
        }
    };
    return {
        init: init
    }
})();

var accountSection = (function() {  
    "use strict";
    var bindEvents = function() {
        if ($('#account-section').length > 0) {
            var contentCache = {};
            function loadContent(target, targetElement) {
                if (contentCache[target]) {
                    targetElement.html(contentCache[target]);
                    if(target == '/user/manage-subscriptions') {
                        if($('#manage-subscription').length > 0) {
                            $('.manage-subscription-btn').on('click', function(e) {
                                e.preventDefault();
                                $('.overlay-loader-target').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
                                $.ajax({
                                    url: '/subscribe/update',
                                    type: 'POST',
                                    success: function(response) {
                                        $('.overlay-loader-target').LoadingOverlay('hide');
                                        if (response.redirectUrl) {
                                            if(response.newTab) {
                                                window.open(response.redirectUrl, '_blank');
                                            } else {
                                                window.location.href = response.redirectUrl;
                                            }
                                        }
                                    },
                                    error: function(xhr, status, error) {
                                        $('.overlay-loader-target').LoadingOverlay('hide');
                                        console.log('Error: ' + error);
                                    }
                                });
                            })
                        }
                    }
                } else {
                    $.ajax({
                        url: target,
                        method: 'GET',
                        beforeSend: function() {
                            $('.overlay-loader-target').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
                        },
                        success: function(data) {
                            contentCache[target] = data.html;
                            targetElement.html(data.html);
                            $('.overlay-loader-target').LoadingOverlay('hide');
                            $('.remove-user-access').on('click', (event) => {
                                var id = event.target.dataset.id;
                                var name = event.target.dataset.name;
                        
                                $('#remove-access .fill-name').html(name);
                                $('#remove-access #confirm-remove-access').attr("href", "/user/invite/remove/" + id);
                        
                                $('#remove-access').modal('show');
                            });
                            if(target == '/user/manage-subscriptions') {
                                if($('#manage-subscription').length > 0) {
                                    $('.manage-subscription-btn').on('click', function(e) {
                                        e.preventDefault();
                                        $('.overlay-loader-target').LoadingOverlay('show', {image : "",fontawesome : "fa fa-circle-notch fa-spin", fontawesomeColor : "#006760"});
                                        $.ajax({
                                            url: '/subscribe/update',
                                            type: 'POST',
                                            success: function(response) {
                                                $('.overlay-loader-target').LoadingOverlay('hide');
                                                if (response.redirectUrl) {
                                                    if(response.newTab) {
                                                        window.open(response.redirectUrl, '_blank');
                                                    } else {
                                                        window.location.href = response.redirectUrl;
                                                    }
                                                }
                                            },
                                            error: function(xhr, status, error) {
                                                $('.overlay-loader-target').LoadingOverlay('hide');
                                                console.log('Error: ' + error);
                                            }
                                        });
                                    })
                                }
                            }
                        },
                        error: function() {
                            targetElement.html('<p>'+translations.error_loading_content+'</p>');
                            $('.overlay-loader-target').LoadingOverlay('hide');
                        }
                    });
                }
            }
            

            $('.nav-pills li a').on('click', function(event) {
                event.preventDefault();
                var contentId = $(this).data('target');
                $('.nav-pills li').removeClass('active');
                $(this).parent().addClass('active');
                loadContent(contentId, $('#pills-content'));
            });

            $('.panel-collapse').on('shown.bs.collapse', function(event) {
                var panelBody = $(this).find('.panel-body');
                var contentId = $(this).prev().data('content');
                // Only load content if it hasn't been loaded yet
                if (!panelBody.hasClass('loaded')) {
                    loadContent(contentId, panelBody);
                    panelBody.addClass('loaded');
                }
            });

            var activePill = $('.nav-pills li.active a').data('target');
            loadContent(activePill, $('#pills-content'));
        }
    }

    var init = function() {
        bindEvents();
    }

    return {
        init: init
    }
})();

var httpEventPublisher = (function () {
    "use strict";

    var postEvent = function(url, data) {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", seenEventURL.value, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                switch (xhr.status) {
                    case 204:
                        console.log('Event published');
                        break;
                    default:
                        let data = JSON.parse(xhr.responseText);
                        console.log('Error publishing event', data);
                }
            }
        }
        if (data) {
            xhr.send(JSON.stringify(data));
            return;
        }
        xhr.send();
    }

    var init = function() {
        var seenEventURL = document.getElementById('seenEventURL');
        if (seenEventURL) {
            postEvent(seenEventURL.value, null);
        }
    }

    return {
        init: init
    }
})();

var setClientTimezoneInput = (function () {
    "use strict";

    var init = function() {
        const shouldSetClientTimezone = document.getElementById('set-client-timezone');
        if (shouldSetClientTimezone) {
            let url = shouldSetClientTimezone.dataset.url;
            if (!url) {
                console.log('Error: No URL provided to set client timezone');
                return;
            }

            let xhr = new XMLHttpRequest();
            xhr.open('POST', url, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.onload = function() {
                var response = JSON.parse(xhr.responseText);
                switch (xhr.status) {
                    case 201:
                        console.log('Client timezone set successfully', 'Timezone:' + response.timezone);
                        return;
                    case 400:
                    case 405:
                        console.log('Failed to set client timezone', 'Error: ' + response.Error);
                        return;
                    default:
                        console.log('Failed to set client timezone', 'Status: ' + xhr.status);
                        return;
                }

            };
            xhr.send(JSON.stringify({timezone: Intl.DateTimeFormat().resolvedOptions().timeZone}));
            console.log("Setting client timezone...");
        }
    }

    return {
        init: init
    }
})();

$(document).ready(function() {
    if (location.hash) {
        setTimeout(function() {

          window.scrollTo(0, 0);
        }, 1);
    }
    dashboard.init();
    addressLookup.init();
    showHide.init();
    addMicrochip.init();
    passwordBox.init();
    accountTabs.init();
    passwordStrength.init();
    submitButtonAnimation.init();
    formConfirm.init();
    reasonConfirm.init();
    modalControl.init();
    emailVerifiedPoll.init();
    identityVerifiedPoll.init();
    locationType.init();
    vaccinations.init();
    insurance.init();
    reportMissing.init();
    racehorse.init();
    registration.init();
    stripePayment.init();
    stripeIntent.init();
    changeOwnership.init();
    registerUpdate.init();
    detailsIncorect.init();
    chipChecker.init();
    chipCheckerPopup.init();
    dismissedComponents.init();
    ownershipStatus.init();
    poaVerifiedPoll.init();
    changeReason.init();
    universalSearch.init();
    pioCountryChange.init();
    locationChange.init();
    saveLocation.init();
    btnLocationSubmit.init();
    newOwnerSelect.init();
    previousOwnerSelect.init();
    saveRiders.init();
    btnRiderSubmit.init();
    vehicleNumber.init();
    saveVehicles.init();
    selectEquinePassports.init();
    selectNewUserRole.init();
    selectEditUserRole.init();
    handleFormChange.init();
    rvcOptIn.init();
    selectAllCheckboxes.init();
    movementsA2BLocations.init();
    movementsA2BConfirm.init();
    movementsA2BView.init();
    addressLookupMulti.init();
    previousOwnerSelect.init();
    fetchNotitifcation.init();
    validateVerifyForm.init();
    uelnSearchBtn.init();
    microchipSearchBtn.init();
    ownershipConfirm.init();
    selectPicaRole.init();
    equineLocations.init();
    autoCompleteAddressLookup.init();
    mobileVerifiedPoll.init();
    membershipSearchBtn.init();
    comingSoonSubscribeForm.init();
    updateEquineLocations.init();
    paymentSelectionBtn.init();
    subscriptionPayment.init();
    accountSection.init();
    httpEventPublisher.init();
    setClientTimezoneInput.init();
});


window.initTypeahead = function(selector, source, selectCallback, changeCallback) {
    return $(selector).typeahead({
        source: source,
        minLength: 1,
        fitToElement: true,
        afterSelect: selectCallback
    }).on('change', changeCallback);
}